import {
    useContext,
    useMemo,
    useEffect,
    useState,
    useCallback,
    useRef,
} from "react";
import { CheckInContext } from "../context/checkin";
import { useWebPush } from "../context/webpush";
import { statusClass, getCDNImage } from "../globals";
import {
    Form,
    Button,
    Card,
    Col,
    Row,
    Container,
    InputGroup,
    Alert,
    Modal
} from "react-bootstrap";
import Screen from "../components/Screen";
import { T, TF } from "react-translator-component";
// import Comments from '../components/Comments';
import { usePersistentState } from "../hooks/usePersistentState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowRight,
    faCaretRight,
    faPen,
    faArrowLeft,
    faAngleLeft,
    faCheckCircle,
    faClock,
    faExclamationCircle,
    faCalendarAlt,
    faArrowCircleRight,
    faArrowCircleLeft,
    faLongArrowAltRight,
    faUsers,
    faComment,
    faInfoCircle,
    faWindowClose,
    faTimesCircle,
    faMoneyBill,
    faMoneyCheck,
    faPlusCircle,
    faCheck,
    faCheckSquare,
    faSquare,
    faEnvelope

} from "@fortawesome/free-solid-svg-icons";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useNavigate, useLocation } from "react-router-dom";
import { Building } from "../components/Icons";
import { invertDate, formatDate, formatDayMonth, dataURLtoBlob, calculateHoursUntil, htmlToText, slugify, roomData, reservationDisplayCode } from "../functions";
import ProgressSteps from "../components/ProgressSteps";
import Reservation from "../components/Reservation";
import CheckInHeader from "./CheckIn/Header";
import { currencyFormat, i18nValue, getLocale } from '../functions';
import SignatureCanvas from 'react-signature-canvas';
import { Storage } from "aws-amplify";
import UpSellingListContainer from "../components/UpSelling/UpSellingListContainer";
import TermsAndConditionsModal from "../components/CheckIn/TermsAndConditionsModal";
import { getRoomCategories } from "../actions/hotelActions";
import { PhoneInputI18n } from "../components/PhoneInputI18n";
import showHouseKeeping from "../components/CheckIn/showHouseKeeping";
import { format, parseISO } from "date-fns";
import processHtml from "../components/processHtml";
import useUpsell from "../hooks/useUpsells";
import { ErrorMessages } from "../components/ErrorMessages";
import { Edit as EditIcon, Avatar } from "../components/Icons";
import { GetCheckinTime } from "../configs/getStayTimes";
import PassengerItemComponent from "./CheckIn/PassengerItemComponent";
import PassengerItemResume from "./CheckIn/PassengerItemResume";
import { Payment } from "../components/Payment";
import { isBelAir, isHostz, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzMyde, isHostzSanCarlo, isHostzSteiners, isHostzSwissstay, isOffgrid, isSimplex, isRoyal, isDemo, isNewsletterHotel } from "../components/CheckIn/hotelConditions";
// import CheckinCompleted from "./CheckIn/CheckinCompleted";
import useCheckInActions from "../hooks/useCheckInActions";
import { PaymentCart } from "../components/PaymentCart";
import { usePaymentContext, PaymentControls, PAYMENT_STATUSES } from "../context/payment";
import { getCountriesList } from "../configs/getCountriesList";
import { Player } from '@lottiefiles/react-lottie-player';
import { useKiosk } from "../hooks/useKiosk";
import './CheckInDetailNew.css';

const CheckInDetailNew = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isKioskMode } = useKiosk();
    const ScreenComponent = useRef();
    const paymentCheckoutRef = useRef(null);
    const {
        data: checkIn,
        webCheckInDone,
        sendToValidate,
        validateAt,
        validate,
        setNewsletter,
        setTravelType,
        setArrivalMode,
        setEmail,
        setPhone,
        setEntryTime,
        setComment,
        setSign,
        setExtraData,
        errors,
        resetErrors,
        setPassengerOmmit,
        setPassengerLinkedCheckinOmmit,
        getBalancePaymentUrl,
        nights,
        stayClear
    } = useContext(CheckInContext);
    const { data: hotel, sectionsByCode, extra } = useContext(HotelContext);
    const { rate, language } = useContext(UserContext);
    const [sending, setSending] = useState(false);
    const [editMode, setEditMode] = usePersistentState(
        `checkIn-editMode-${checkIn.timestamp ?? "0"}`,
        false
    );
    const [stepCurrentPosition, setStepCurrentPosition] = usePersistentState(
        `checkIn-currentPosition-${checkIn.timestamp ?? "0"}`,
        1,
        60 * 24 * 7 // 7 días
    );
    // const [showRequestPermission, setShowRequestPermission] = useState(false);
    const [showSignModal, setShowSignModal] = useState(false);

    const {
        setPaymentCheckoutRef,
        setCart: paymentSetCart,
        setActive,
        dropinVisible,
        status: paymentStatus,
        allowSkipPayment,
        setOptionPayLater: setPaymentOptionPayLater,
        lastError: paymentLastError,
    } = usePaymentContext();
    const [paymentState, setPaymentState] = useState('initial');
    const [paymentError, setPaymentError] = useState(null); // TODO::: hacer junto con los otros errores
    const [paymentOmmited, setPaymentOmmited] = useState(false);
    const [cupsItems, setCupsItems] = useState([])
    const [stepError, setStepError] = useState(false)
    // const [roomCategoriesMap, setRoomCategoriesMap] = useState({})
    // const [ loadingBalance, setLoadingBalance ] = useState(true);
    const { getUpsellingList } = useUpsell();
    const [upsellingsLoaded, setUpsellingsLoaded] = useState(false);

    const [redirectIsCounting, setRedirectIsCounting] = useState(false);
    const [redirectCount, setRedirectCount] = useState(8); // Inicializa en 5 segundos

    const [nextDisabled, setNextDisabled] = useState(false);
    const [totalCart, setTotalCart] = useState({});
    const [showPaymentByUpselling, setShowPaymentByUpselling] = useState(null);

    const [onlyPaymentsByUpselling, setOnlyPaymentsByUpselling] = useState(false);
    const [paymentComponentVersion, setPaymentComponentVersion] = useState(null);

    const room = roomData(checkIn, language);
    // console.log('12feb room', room);

    let signCanvas = null;
    const sortedCountries = getCountriesList();
    const [cartNew, setCartNew] = useState([]);
    const [account, setAccount] = useState(null);
    const [isPaidDepositGaarantee, setIsPaidDepositGaarantee] = useState(false);
    const [allRequireds, setAllRequireds] = useState(true);
    const [optionPayLater, setOptionPayLater] = useState(false);
    const { getAccount } = useCheckInActions();

    useEffect(() => {

        // Voy a buscar el balance
        // getBalance(hotel?.id, checkIn?.id).then(res => {
        getAccount(hotel?.id, checkIn?.id).then(res => {
            setAccount(res);
            setIsPaidDepositGaarantee(res?.depositGuarantee?.paid)
            setOptionPayLater(res?.ommitStep);


            setPaymentComponentVersion(res?.gateway?.config?.component || "v1");
            setPaymentOptionPayLater(res?.ommitStep);
        });


    }, []);

    useEffect(() => {

        let arrayWithIds = []
        let onlyDepositGuarantee = false;

        if (!isKioskMode && (account?.balance?.charges && !onlyPaymentsByUpselling)) {

            arrayWithIds = (Object.entries(account.balance.charges) || [])
                // .filter(([key, value]) => value.amount > 0)
                .map(([key, value]) => ({
                    ...value,
                    id: key,
                    required: allRequireds,
                    selected: true
                }));

            let arrayPayments = [];
            // Solo muestro los pagos si existen items a mostrar en el carro
            if (arrayWithIds.length > 0) {
                arrayPayments = (Object.entries(account.balance.payments) || [])
                    .map(([key, value]) => ({
                        ...value,
                        id: key,
                        name: T('payments.older'),
                        desc: formatDate(value.date, true),
                        amount: -1 * (value.amount),
                        required: true,
                        selected: true,
                        isPayment: true
                    }));

                if (arrayPayments) {
                    arrayWithIds = [...arrayWithIds, ...arrayPayments];
                    // arrayWithIds = (Object.assign(arrayWithIds, arrayPayments)).sort((a, b) => (a.isPayment ? 1 : -1));
                }
            }

            console.log('000000', arrayWithIds);

            if (account.depositGuarantee?.show && !account.depositGuarantee?.paid) {
                if (arrayWithIds.length == 0) {
                    onlyDepositGuarantee = true;
                }
                arrayWithIds.unshift(
                    {
                        amount: account.depositGuarantee?.amount || 500,
                        id: "GuaranteeDeposit",
                        name: T("payments.guarantee-deposit"),
                        qty: 1,
                        desc: T("payments.guarantee-deposit-desc"),
                        required: account.depositGuarantee?.required || false,
                        selected: true,
                        isSecurityDeposit: true
                    }
                );
            }

        }

        console.log('21feb - showPaymentByUpselling arrayWithIds', arrayWithIds)

        if (!isKioskMode && showPaymentByUpselling) {
            let auxUpselling = { ...showPaymentByUpselling }
            auxUpselling.required = true;
            auxUpselling.selected = true;
            auxUpselling.isUpselling = true;
            arrayWithIds = [...arrayWithIds, auxUpselling];
        }

        setCartNew(arrayWithIds);

    }, [account, showPaymentByUpselling, onlyPaymentsByUpselling])


    useEffect(() => {
        if (checkIn) {
            resetErrors();

            if (pathname.indexOf('checkin/edit') !== -1) {
                setEditMode(true);
            } else {
                if (checkIn.status === "pending" || checkIn.status === "observed" || (checkIn.status === "in_stay" && !webCheckInDone)) {
                    setEditMode(true);
                }

                if (checkIn.status === "done") {
                    setEditMode(false);
                }
            }

            // setCupsItems([
            //   { 
            //     "id": "own-123",
            //     "provider": "own", 
            //     "crossUpSellingId": "123", 
            //     "titleI18n": { "es-ES": "Check-in y check-out flexible" }, 
            //     "descriptionI18n": { "es-ES": "Puedes ingresar desde la mañana e irte por la tarde mejorando tu estadía." }, 
            //     "photo": "https://nomadante.com/wp-content/uploads/2022/10/que-es-el-check-in-en-un-hotel-todas-las-preguntas-frecuentes-que-temes-hacer-1-1140x641.jpg",
            //     "price": 11.90
            //   },
            //   { 
            //     "id": "own-456",
            //     "provider": "own", 
            //     "crossUpSellingId": "456", 
            //     "titleI18n": { "es-ES": "Copa de Bienvenida" }, 
            //     "descriptionI18n": { "es-ES": "Nuestro equipo te da la más cordial bienvenida, esperamos que su estancia sea inolvidable." }, 
            //     "photo": "https://www.pagodecirsus.com/themes/pagodecirsus/images/hotel-y-restaurante/hotel/galeria/pagode-cirsus-16.jpg",
            //     "price": 9.80
            //   },
            //   { 
            //     "id": "civitatis-456",
            //     "provider": "civitatis", 
            //     "code": "456", 
            //     "titleI18n": { "es-ES": "Entrada al Museo Belvedere" }, 
            //     "descriptionI18n": { "es-ES": "Con esta entrada al Museo Belvedere de Viena visitaréis una de las colecciones de arte más importantes de Austria. En el Alto Belvedere veréis obras tan famosas como El Beso de Klimt. Por su parte, el Bajo Belvedere alberga una destacada colección medieval." }, 
            //     "photo": "https://www.civitatis.com/f/austria/viena/entrada-museos-belvedere-589x392.jpg",
            //     "price": 14.60
            //   },
            //   { 
            //     "id": "civitatis-789",
            //     "provider": "civitatis", 
            //     "code": "789", 
            //     "titleI18n": { "es-ES": "Excursión a Hallstatt" }, 
            //     "descriptionI18n": { "es-ES": "Con esta entrada al Museo Belvedere de Viena visitaréis una de las colecciones de arte más importantes de Austria. En el Alto Belvedere veréis obras tan famosas como El Beso de Klimt. Por su parte, el Bajo Belvedere alberga una destacada colección medieval." }, 
            //     "photo": "https://www.civitatis.com/f/austria/viena/excursion-hallstatt-589x392.jpg",
            //     "price": 116
            //   },
            //   { 
            //     "id": "civitatis-999",
            //     "provider": "civitatis", 
            //     "code": "999", 
            //     "titleI18n": { "es-ES": "Concierto Palacio Schönbrunn" }, 
            //     "descriptionI18n": { "es-ES": "Viena es música, por lo que disfrutar de un concierto en el Palacio Schönbrunn de música clásica es una experiencia que se ha convertido en casi imprescindible." }, 
            //     "photo": "https://www.civitatis.com/f/austria/viena/galeria/concierto-palacio-schonbrunn.jpg",
            //     "price": 90
            //   },
            //   { 
            //     "id": "civitatis-888",
            //     "provider": "civitatis", 
            //     "code": "888", 
            //     "titleI18n": { "es-ES": "Misterios y leyendas de Viena" }, 
            //     "descriptionI18n": { "es-ES": "Crueles asesinatos y oscuros secretos se esconden en los rincones del casco histórico de la capital de Austria. Los conoceremos todos con el tour de los misterios y leyendas de Viena. " }, 
            //     "photo": "https://www.civitatis.com/f/austria/viena/tour-misterios-leyendas-viena-589x392.jpg",
            //     "price": 18
            //   }
            // ])

            // -- Parche
            // if (!checkIn.travelType) {
            //   setStepCurrentPosition(1);
            // }
            // -- Parche

            // const notif = getNotificationObject();
            // if (notif) {
            //   if (notif.permission === "granted") {
            //     setShowRequestPermission("accepted");
            //   } else {
            //     setShowRequestPermission(
            //       notif.permission === "default" ? "accept" : "fix"
            //     );
            //   }
            // }
            // if (paymentState === 'redirect') {
            //   setPaymentState('done');
            // }
        }
    }, []);

    useEffect(() => {
        // Solo activa el intervalo si isCounting es true
        if (redirectIsCounting) {
            const interval = setInterval(() => {
                setRedirectCount((prevCount) => prevCount - 1);
            }, 1000);

            // Redirecciona cuando el contador llegue a 0
            if (redirectCount === 0) {
                if(isKioskMode) {
                    navigate(`/${hotel.code}/kiosk/welcome-kiosk`, { replace: true });
                }else{
                    navigate(`/${hotel.code}/checkin/status`);
                }
            }

            // Limpia el intervalo al desmontar el componente o cuando count llegue a 0
            return () => clearInterval(interval);
        }
    }, [redirectIsCounting, redirectCount, navigate]);

    useEffect(() => {
        let totalAmount = 0;
        let arrayUpsellongs = null;

        console.log('000 - cartNew', cartNew);
        console.log('000 - account', account);

        if (cartNew && account?.balance?.detail) {
            console.log('account.balance', account.balance);
            if (!totalCart.onlyDepositGuarantee) {
                totalAmount = account.balance.charges.reduce((sum, item) => sum + item.amount, 0);
            } else {
                totalAmount = (account.depositGuarantee.amount / 100);
            }
        }

        if (showPaymentByUpselling && showPaymentByUpselling.inCart && showPaymentByUpselling.amount > 0) {
            totalAmount += showPaymentByUpselling.amount;
            arrayUpsellongs = showPaymentByUpselling.descList;
        }

        const _amounts = {
            security_deposit: {
                value: 0,
                currency: paymentCurrency
            },
            webcheckin: {
                value: totalAmount,
                currency: paymentCurrency
            },
            add_ons: {
                value: 0,
                currency: paymentCurrency
            }
        }

        if (arrayUpsellongs && arrayUpsellongs.length > 0) {
            arrayUpsellongs.forEach(add_on => {
                const _price_to_payment = add_on.amount.value;
                _amounts["add_ons"].value += _price_to_payment;
                _amounts["webcheckin"].value -= _price_to_payment;
            })
        }

        const _cart = { ...totalCart, amount: 100 * totalAmount, amounts: _amounts, add_ons: arrayUpsellongs }
        console.log('HOY - _cart', _cart)
        setTotalCart(_cart);
    }, [cartNew, account, showPaymentByUpselling]);

    useEffect(() => {
        console.log('PAYMENT - 000: checkIn.crossUpSelling', checkIn.crossUpSelling);
        let auxShowPayments = {
            amount: 0,
            id: "Upsellings",
            name: "Add-ons", // T("payments.upsellings"),
            qty: 0,
            desc: '',
            descList: [],
            inCart: true
        };
        checkIn?.crossUpSelling?.forEach(element => {
            // Soporta option único (optionSelected) y paquete type "items" (optionSelected.price = precio paquete)
            const _pricePerNight = element.priceIsPerNight ? (nights || 1) : 1;
            const _price = _pricePerNight * (element.optionSelected?.price ?? element.price ?? 0);
            const _qty = element.optionSelected?.qty ?? 1;
            const _item = {
                id: element.id,
                name: element.title,
                internalKey: checkIn.id + "_upselling_" + (element.optionSelected?.id || element.id),
                slug: slugify(element.title),
                // amount: element.price,
                coloquial: `${element.title} -  ${_price > 0 ? `${currencyFormat(_price, paymentCurrency)}` : (_price === 0 ? T("general.no-charge") : "")}`,
                // type: null,
                // config: null,
                qty: _qty,
                amount: {
                    valueDecimal: _price,
                    value: _price * 100,
                    currency: paymentCurrency
                },
                values: element.settingData?.values || ""
            }
            auxShowPayments.descList.push(_item);
            if (_item.amount.value > 0) {
                auxShowPayments.amount += _item.amount.valueDecimal;
            }
            auxShowPayments.qty += 1;
        });

        console.log('12feb - auxShowPayments.descList', auxShowPayments.descList)

        if (auxShowPayments.amount > 0) {
            // Agrego a carro
            addToCart('Upsellings');
            setShowPaymentByUpselling(auxShowPayments);
        } else {
            // Quito del carro
            removeToCart('Upsellings');
            setShowPaymentByUpselling(null);
        }


    }, [checkIn?.crossUpSelling]);

    // useEffect(() => {
    //   if (!checkIn || Object.keys(checkIn).length === 0 || checkIn?.status === "in_stay" || checkIn?.status === "accepted") return;
    //   const roomCategoriesMap = {}
    //   if (items && items.length > 0) {
    //     items.map(r_item => {
    //       roomCategoriesMap[r_item.id] = r_item.code;
    //     })
    //     setRoomCategoriesMap(roomCategoriesMap)
    //   }
    // }, [hotel.id, items]);


    useEffect(() => {
        if (!checkIn || webCheckInDone || Object.keys(checkIn).length === 0 || checkIn?.status === "in_stay" || checkIn?.status === "accepted") {
            setCupsItems([]);
            setUpsellingsLoaded(true);
            return;
        } else {
            getUpsellingList(hotel.id).then(r => {
                if (!r) {
                    setCupsItems([]);
                    setUpsellingsLoaded(true);
                    return;
                }

                if (false &&
                    hotel?.id === "d4676e50-71ed-4c01-bcdf-84b2b55b1890" &&
                    checkIn?.id !== "f711f87a-cb12-4ada-b516-3bcfaa315661" &&
                    checkIn?.id !== "acc7448b-4120-4228-a7b8-c210ffcac68f" &&
                    checkIn?.id !== "1cee92c0-32a1-4174-87d1-aaa464a8b361") {
                    setCupsItems([]);
                } else {
                    setCupsItems(r.filter(cup => cup.active === true));
                    setUpsellingsLoaded(true);
                }

            });
        }

    }, [hotel.id, checkIn?.status, webCheckInDone]);

    // console.log('11feb - cupsItems', cupsItems)

    const showCarOptions = useMemo(() => {
        // console.log('1401 - arrivalMode', checkIn?.arrivalMode)
        // console.log('1401 - hotel.id', hotel.id)
        return checkIn?.arrivalMode === "car" && isHostzBlackSummit(hotel.id);
    }, [hotel?.id, checkIn?.arrivalMode, isHostzBlackSummit])


    const filteredCupsList = useMemo(() => {

        if (checkIn) {


            const { arrivalMode, rate, RoomCategory, balance } = checkIn;
            let filteredCups = [];

            const reservation_roomcategory = RoomCategory?.id || "";


            cupsItems.map(cup => {

                console.log('11feb - cup', cup)

                let showCup = true;

                if (cup.arrivalMode && cup.arrivalMode.length > 0 && arrivalMode) {
                    showCup = cup.arrivalMode.includes(arrivalMode);
                }

                console.log('11feb - showCup 1', showCup)

                if (cup.roomTypes && cup.roomTypes.length > 0) {
                    showCup = cup.roomTypes.includes(reservation_roomcategory);
                }

                console.log('11feb - showCup 2', showCup)

                if (cup.rates && cup.rates.length > 0) {
                    console.log('11feb - showCup 3 - cup.rates', cup.rates)
                    const _rates = cup.rates.filter(r => r === rate);
                    showCup = _rates.length > 0;
                }

                console.log('11feb - showCup 5', showCup)
                if (showCup) {
                    console.log('11feb - showCup 6', showCup)
                    filteredCups.push(cup);
                }
            })

            console.log('11feb - filteredCups', filteredCups)

            return filteredCups;
        } else {
            return cupsItems;
        }
    }, [checkIn, cupsItems]);

    const actualObservations = useMemo(() => {
        let _obs = [];

        checkIn.evolutions &&
            checkIn.evolutions.map((ev) => {
                if (ev.status === checkIn.status) {
                    _obs.push(ev);
                } else if (ev.status !== null) {
                    _obs = [];
                }
            });
        // }
        return _obs;
    }, [checkIn?.evolutions, checkIn?.status]);

    const countryCode = useMemo(() => {
        const cc = checkIn?.passengers?.[0]?.residence || checkIn?.passengers?.[0]?.nationality || null;
        // console.log('20ene - cc', cc);
        return cc;
    }, [checkIn?.passengers])

    const showIsForeignMsg = useMemo(() => {
        if (!isBelAir(hotel?.id)) {
            return false;
        }
        const show = checkIn?.passengers?.[0]?.nationality != "AR";
        console.log('20ene - showIsForeignMsg', show);
        return show;
    }, [hotel, checkIn?.passengers]);

    const handleBalancePay = useCallback(() => {
        if (!checkIn?.id) return;
        setPaymentState('loading-payment-link')
        getBalancePaymentUrl(hotel.id, checkIn.id).then(r => {
            r = JSON.parse(r);
            if (r.url) {
                window.location.href = r.url;
            } else {
                setPaymentState('payment-link-error')
            }
        })
    }, [checkIn?.id]);

    // const ageStats = useMemo(() => {
    //     const _stats = { people: 0, adults: 0, boys : 0 }
    //     // const _pass = data?.passengers ? data.passengers : checkIn?.passengers;
    //     const _pass = checkIn.passengers;
    //     _pass && _pass.map((row, idx) => {
    //       _stats.people++
    //       if (!isNaN(row.age)) {
    //         row.age >= 18 ? _stats.adults++ : _stats.boys++;
    //       }
    //     });
    //     return _stats;
    //   }, [checkIn])

    // const ageStatsText = useMemo(() => {
    //   let parts = [];
    //   if (ageStats.people === (ageStats.adults + ageStats.boys)) {
    //     if (ageStats.adults > 0) {
    //       parts.push(ageStats.adults + ' adulto' + (ageStats.adults > 1 ? 's' : ''))
    //     }
    //     if (ageStats.boys > 0) {
    //       parts.push(ageStats.boys + '  niño' + (ageStats.boys > 1 ? 's' : ''))
    //     }
    //   } else {
    //     parts.push(ageStats.people + ' persona' + (ageStats.people > 1 ? 's' : ''))
    //   }
    //   return parts.join(' / ')
    // }, [ageStats])

    const { guestsText, guestBalance } = useMemo(() => {
        if (!checkIn.reservation) return { guestsText: "", guestBalance: null };
        const _arr = [];
        if (checkIn.reservation.adults) {
            _arr.push(
                checkIn.reservation.adults +
                " " +
                (checkIn.reservation.adults > 1
                    ? T("checkin.adults")
                    : T("checkin.adult"))
            );
        }
        let auxBalance = checkIn.reservation?.balance ?? null;
        if (!auxBalance?.detail && checkIn.balance?.detail) {
            auxBalance = checkIn.balance;
            auxBalance.amount = checkIn.balance.total;
        }
        return { guestsText: _arr.join(" / "), guestBalance: auxBalance };

        // {checkIn.reservation.adults} {T('checkin.adult-s')} / {checkIn.reservation.childrenAges?.length}
    }, [checkIn?.reservation]);

    // const { showGuaranteeDeposit, showOptionNoPayment, noShowItemInCart, more72hs } = useMemo(() => {
    //     if (!checkIn.reservation) return { noShowItemInCart: [], showGuaranteeDeposit: false, showOptionNoPayment: false, more72hs: false };

    //     let noShowItemInCart = [];
    //     let showGD = true;
    //     let showOmmit = false;
    //     let isMore72hs = false;

    //     console.log('PAYMENT - checkin', checkIn);

    //     const hours = calculateHoursUntil(checkIn.reservation.arrival);
    //     console.log('PAYMENT - hours to arrive', hours);
    //     if (hours >= 72) {
    //         // Faltan más de 72 horas, no muestro garantía y permito continuar
    //         showGD = false;
    //         showOmmit = true;
    //         isMore72hs = true;
    //     }

    //     // Criterios por Hotel y Channel

    //     // Becozy
    //     if (hotel.id === "9983de2a-9f3e-4c75-9fb9-62e9855681e8") {
    //         showGD = false;
    //         if (!checkIn.channel?.toLowerCase().includes('direct') &&
    //             !checkIn.channel?.toLowerCase().includes('roomcloud ibe')
    //         ) {
    //             noShowItemInCart = ['accommodation_timeslice', 'accommodation_n/a'];
    //         }
    //     }

    //     // Black Summit, BetaHouse, Arosa, TheMyde, cozy
    //     if (hotel.id === "d4676e50-71ed-4c01-bcdf-84b2b55b1890" || hotel.id === "efcf9764-9157-4454-9d24-76a053906322" || hotel.id === "af8e44a0-c64c-4647-bb12-abd0af4b4a4b" || hotel.id === "59f21e07-f8a4-46f0-b294-b74f03348a9f" || hotel.id === "ba6598fa-6808-417a-a391-250aeb89745e") {
    //         if (checkIn.channel?.toLowerCase() !== 'direct' &&
    //             !checkIn.channel?.toLowerCase().includes('dirs21 direct') &&
    //             !checkIn.channel?.toLowerCase().includes('bookingbutton') &&
    //             !checkIn.channel?.toLowerCase().includes('booking direct') &&
    //             checkIn.channel?.toLowerCase() !== 'ibe'
    //         ) {
    //             noShowItemInCart = ['accommodation_timeslice', 'accommodation_n/a', 'other_'];
    //         }
    //         // Excluyo Booking
    //         if (checkIn.channel?.toLowerCase().includes('booking.com')) {
    //             noShowItemInCart = ['accommodation_timeslice', 'accommodation_n/a', 'other_'];
    //         }
    //         if (checkIn.channel?.toLowerCase().includes('airbnb')) {
    //             showGD = false;
    //         }
    //     }

    //     // Gemunder => Solo lo que esté en el folio 1 y si la tarjeta es virtual no cobrar estadía
    //     if (hotel.id === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516") {
    //         console.log('ROBIN', checkIn);
    //         if (checkIn.balance?.detail) {
    //             noShowItemInCart = Object.entries(checkIn.balance.detail)
    //                 .filter(([_, charge]) => charge.folio?.number !== 1)
    //                 .map(([key]) => key);

    //             console.log('ROBIN noShowItemInCart 1', noShowItemInCart);
    //             if (checkIn.balance.detail.paymentAccount?.isVirtual) {
    //                 const aux = ['accommodation_timeslice', 'accommodation_n/a', 'other_'];
    //                 noShowItemInCart = [...noShowItemInCart, ...aux];
    //             }
    //         }
    //         console.log('ROBIN noShowItemInCart FINAL', noShowItemInCart);
    //         if (checkIn.channel?.toLowerCase().includes('airbnb')) {
    //             showGD = false;
    //         }
    //     }

    //     // DEV Matias
    //     if (hotel.id === "511e8df9-672d-42b1-9711-d82beb7baf64") {
    //         showOmmit = true;

    //         //--- Condiciones ROBIN -->
    //         console.log('ROBIN', checkIn);
    //         if (checkIn.balance?.detail) {
    //             noShowItemInCart = Object.entries(checkIn.balance.detail)
    //                 .filter(([_, charge]) => charge.folio?.number !== 1)
    //                 .map(([key]) => key);

    //             console.log('ROBIN noShowItemInCart 1', noShowItemInCart);
    //             if (checkIn.balance.detail.paymentAccount?.isVirtual) {
    //                 const aux = ['accommodation_timeslice', 'accommodation_n/a', 'other_'];
    //                 noShowItemInCart = [...noShowItemInCart, ...aux];
    //             }
    //         }
    //         console.log('ROBIN noShowItemInCart FINAL', noShowItemInCart);
    //         if (checkIn.channel?.toLowerCase().includes('airbnb')) {
    //             showGD = false;
    //         }
    //         //<-- Condiciones Robin ---

    //     }

    //     if (hotel.id === "b58142a6-dfbc-4b7a-ab7e-8bac3e848b51") {
    //         showGD = false;
    //         showOmmit = true;
    //         if (checkIn.channel?.toLowerCase() !== 'direct' &&
    //             !checkIn.channel?.toLowerCase().includes('agoda') &&
    //             !checkIn.channel?.toLowerCase().includes('roomcloud') &&
    //             !checkIn.channel?.toLowerCase().includes('hotel_collect') &&
    //             !checkIn.channel?.toLowerCase().includes('other')
    //         ) {
    //             noShowItemInCart = ['accommodation_timeslice', 'accommodation_n/a', 'other_'];
    //         }
    //     }

    //     return { noShowItemInCart: noShowItemInCart, showGuaranteeDeposit: showGD, showOptionNoPayment: showOmmit, more72hs: isMore72hs };

    //     // {checkIn.reservation.adults} {T('checkin.adult-s')} / {checkIn.reservation.childrenAges?.length}
    // }, [checkIn?.reservation]);



    const guidelineContent = useMemo(() => {
        console.log('11nov - language', language);
        console.log('11nov - extra.guidelines', extra.guidelines);
        console.log('11nov - extra.guidelines[language]', extra.guidelines?.[language]);
        if (extra && extra.guidelines && extra.guidelines?.[language]) {
            console.log('11nov - extra.guidelines', extra.guidelines[language]);
            return <span dangerouslySetInnerHTML={{ __html: extra.guidelines[language] }} />
        }
        if (isOffgrid(hotel.id)) {
            return T("checkin.reservation-conditions-text-offgrid");
        }
        if (isHostz(hotel.id)) {
            return false
        }
        return T("checkin.reservation-conditions-text");
    }, [hotel, extra, language]);

    const stayResume = useMemo(() => {
        if (!checkIn.reservation) return false;

        let primaryGuest = [
            checkIn.reservation.primaryGuest.title,
            (checkIn.passengers?.[0]?.name || checkIn.reservation.primaryGuest.firstName),
            (checkIn.passengers?.[0]?.surname || checkIn.reservation.primaryGuest.lastName)
        ].join(" ");
        if (isOffgrid(hotel.id)) {
            primaryGuest = [
                (checkIn.passengers?.[0]?.name || checkIn.reservation.primaryGuest.firstName),
                (checkIn.passengers?.[0]?.surname || checkIn.reservation.primaryGuest.lastName)
            ].join(" ");
        }

        return (

            <Card className={isKioskMode ? 'kiosk-card-generic' : 'shadow'} border="default text-left">
                <h5 className="text-subtitle mt-3 ml-3">
                    <FontAwesomeIcon
                        icon={faCalendarAlt}
                        className={`mr-1 ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`}
                    />{" "}
                    {T("general.stay")}
                </h5>
                <Card.Body className="py-2 px-3">
                    <Row className="mb-2">
                        <Col xs={12}>
                            <div className="d-flex" style={{ gap: 10 }}>
                                <div
                                    style={{
                                        flex: "none",
                                        width: 50,
                                        height: 50,
                                        borderRadius: 5,
                                        borderColor: "#AAA",
                                        borderWidth: 1,
                                        borderStyle: "solid",
                                        textAlign: "center",
                                        background: "#EEE",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {checkIn.RoomCategory?.photo && (
                                        <img
                                            style={{ width: 50, height: 50, borderRadius: 5 }}
                                            src={getCDNImage(checkIn.RoomCategory.photo)}
                                        />
                                    )}
                                    {!checkIn.RoomCategory?.photo && (
                                        <div style={{ marginTop: 10 }}>
                                            <Building width={25} height={25} color="#666666" />
                                        </div>
                                    )}
                                    <span className="general-text-sm">{checkIn.RoomCategory?.m2 && checkIn.RoomCategory?.m2 > 0 ? <b>{checkIn.RoomCategory.m2}m2. </b> : ""}</span>
                                </div>
                                <div className="flex-fill">
                                    <p className="mb-0">
                                        {room.name ??
                                            checkIn.reservation?.unitGroup?.code +
                                            ". " +
                                            checkIn.reservation?.unitGroup?.name}
                                    </p>
                                    <p className="mb-0 general-text-sm" style={{ minHeight: 45 }}>
                                        <span className="text-truncate-3-lines">{processHtml(room.description)}</span>
                                    </p>

                                </div>
                            </div>
                        </Col>
                    </Row>
                    {checkIn.linked_checkins && checkIn.linked_checkins.map((ch, ch_idx) => {
                        let roomCategoryName = i18nValue(ch.Room?.RoomCategory, "name", language);
                        if (!roomCategoryName) {
                            roomCategoryName = ch.Room?.RoomCategory?.code + "." // + checkIn.reservation?.unitGroup?.name;
                        }
                        let roomCategoryDescription = i18nValue(ch.Room?.RoomCategory, "description", language);
                        // if (!roomCategoryDescription) {
                        //   roomCategoryDescription = checkIn.reservation?.unitGroup?.description;
                        // }
                        return (<Row className="mb-2">
                            <Col xs={12}>
                                <div className="d-flex" style={{ gap: 15 }}>
                                    <div
                                        style={{
                                            flex: "none",
                                            width: 50,
                                            height: 50,
                                            borderRadius: 5,
                                            borderColor: "#AAA",
                                            borderWidth: 1,
                                            borderStyle: "solid",
                                            textAlign: "center",
                                            background: "#EEE",
                                            verticalAlign: "middle",
                                        }}
                                    >
                                        {ch.Room?.RoomCategory?.photo && (
                                            <img
                                                style={{ width: 50, height: 50, borderRadius: 5 }}
                                                src={getCDNImage(ch.Room?.RoomCategory.photo)}
                                            />
                                        )}
                                        {!ch.Room?.RoomCategory?.photo && (
                                            <div style={{ marginTop: 10 }}>
                                                <Building width={25} height={25} color="#666666" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex-fill">
                                        <p className="mb-0">{roomCategoryName}</p>
                                        <p className="mb-0 general-text-sm">
                                            {ch.Room?.RoomCategory?.m2 && ch.Room?.RoomCategory?.m2 > 0 ? <b>{ch.Room?.RoomCategory.m2}m2. </b> : ""}
                                            {roomCategoryDescription}
                                        </p>

                                    </div>
                                </div>
                            </Col>
                        </Row>)
                    })}
                    <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                        <Col xs={12}>
                            <div className="d-flex justify-content-between general-text-sm pt-1">
                                <span>{T("checkin.reservation-code")}</span>
                                <span className="text-right font-weight-bold">
                                    {reservationDisplayCode(checkIn)}
                                </span>
                            </div>
                        </Col>
                    </Row>
                    {((editMode &&
                        (stepCurrentPosition === 1 || stepCurrentPosition === 4)) ||
                        !editMode) && (
                            <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                                <Col xs={12}>
                                    <div className="d-flex justify-content-between general-text-sm pt-1">
                                        {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                        <span>{T("checkin.in-out")}</span>
                                        <span className="text-right font-weight-bold">
                                            {formatDayMonth(checkIn.reservation.arrival, T("general.short-dateformat"))}{" "}
                                            {/* {invertDate(formatDate(checkIn.reservation.arrival, false))}{" "} */}
                                            <FontAwesomeIcon
                                                icon={faLongArrowAltRight}
                                                className="mr-1 ml-1 text-muted"
                                            />{" "}
                                            {formatDayMonth(checkIn.reservation.departure, T("general.short-dateformat"))}
                                            {/* {invertDate(
                        formatDate(checkIn.reservation.departure, false)
                      )} */}
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                        <Col xs={12}>
                            <div className="d-flex justify-content-between general-text-sm pt-1">
                                <span>{T("general.guests")}</span>
                                <span className="text-right font-weight-bold">
                                    {guestsText}
                                </span>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                        <Col xs={12}>
                            <div className="d-flex justify-content-between general-text-sm pt-1">
                                <span>{T("checkin.primary-guest")}</span>
                                <span className="text-right font-weight-bold">
                                    {primaryGuest ?? "-"}
                                </span>
                            </div>
                        </Col>
                    </Row>
                    {!isHostzSwissstay(hotel.id) && (checkIn.travelType && ((editMode && stepCurrentPosition === 4) || !editMode)) && (
                        <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                            <Col xs={12}>
                                <div className="d-flex justify-content-between general-text-sm pt-1">
                                    {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                    <span>{T("checkin.type-of-travel")}</span>
                                    <span className="text-right font-weight-bold">
                                        {T(`checkin.travel-type.${checkIn.travelType}`)}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {((editMode && stepCurrentPosition === 4) || !editMode) && (
                        <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                            <Col xs={12}>
                                <div className="d-flex justify-content-between general-text-sm pt-1">
                                    {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                    <span>{T("checkin.e-mail")}</span>
                                    <span className="text-right font-weight-bold">
                                        {checkIn.email}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {((editMode && stepCurrentPosition === 4) || !editMode) && (
                        <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                            <Col xs={12}>
                                <div className="d-flex justify-content-between general-text-sm pt-1">
                                    {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                    <span>{T("checkin.phone")}</span>
                                    <span className="text-right font-weight-bold">
                                        {checkIn.phone}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {!editMode && (
                        <Row style={{ borderTop: "1px solid #EEE", paddingBottom: 5 }}>
                            <Col xs={12}>
                                <div className="d-flex justify-content-between general-text-sm pt-1">
                                    {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                    <span>{T("checkin.passengers")}</span>
                                    <span className="text-right font-weight-bold">
                                        {guestsText}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {false && <Row style={{ borderTop: "1px solid #EEE" }}>
                        <Col xs={12}>
                            <div className="d-flex justify-content-between general-text-sm pt-1">
                                {/* <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length} children)</span></span> */}
                                <span>Total</span>
                                <span className="text-right font-weight-bold">
                                    {checkIn.reservation.totalGrossAmount.amount}{" "}
                                    {checkIn.reservation.totalGrossAmount.currency}
                                </span>
                            </div>
                        </Col>
                    </Row>}
                </Card.Body>


            </Card>
        );
    }, [checkIn, stepCurrentPosition, editMode]);

    const headerInfo = useMemo(() => {
        if (editMode || !checkIn.reservation) return false;
        return (
            <div className="reservation-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }}>
                <Reservation
                    showPrice={false}
                    showRowInfo={!isHostzSwissstay(hotel.id)} />
                {/* <Card className="mb-1 w-100 rounded-0 border-top-0 border-left-0 border-right-0">
        <Card.Body className="pt-0 pb-2 px-3 mx-0">
            <Row className="mb-2">
                <Col xs={12}>
                <div className='d-flex' style={{ gap: 15 }}>
                    <div>
                    <img style={{ width: 75, height: 75, borderRadius: 5 }} src={roomCategory?.photo ? getCDNImage(roomCategory.photo) : null} />
                    </div>
                    <div>
                    <p className='mb-0'>{roomCategory?.name ?? (checkIn.reservation?.unitGroup?.code ? checkIn.reservation.unitGroup.code + '. ' + checkIn.reservation.unitGroup.name : '-')}</p>
                    <p className='mb-0 general-text-sm'>{roomCategory?.m2 ? (<b>{roomCategory.m2}m2.</b>) : ''} {roomCategory?.description ?? (checkIn.reservation?.unitGroup?.description ? checkIn.reservation.unitGroup.description : '-')}</p>
                    </div>
                </div>
                </Col>
            </Row>
            <Row style={{ borderTop: '1px solid #EEE' }}>
                <Col xs={12}>
                    <div className='d-flex justify-content-between general-text-sm pt-1'>
                        <span><FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.arrival, false))} - {invertDate(formatDate(checkIn.reservation.departure, false))} <span className='font-italic text-muted'>({checkIn.reservation.adults} adults / {checkIn.reservation.childrenAges?.length ?? "0"} children)</span></span>
                        <span className='text-right font-weight-bold'>{checkIn.reservation.totalGrossAmount.amount} {checkIn.reservation.totalGrossAmount.currency}</span>
                    </div>
                </Col>
            </Row>
        </Card.Body>
    </Card> */}
            </div>
        );
    }, [checkIn, editMode, hotel]);

    const paymentCurrency = useMemo(() => {
        if (checkIn?.balance?.currency) {
            return checkIn.balance.currency
        }
        return "CHF"
    }, [checkIn]);

    const _sendToValidate = () => {
        if (!validateAt("sign")) {
            // Si la firma no está completa, abrir el modal
            setShowSignModal(true);
            validate();
        } else {
            // Si la firma está completa, proceder con la validación
            setSending(true);
            // console.log("0210 - ", editMode);
            setEditMode(false);
            // console.log("0210 - ", editMode);
            sendToValidate()
                .then((r) => {
                    if(isKioskMode) {
                        navigate(`/${hotel.code}/kiosk/welcome-kiosk`, { replace: true });
                    }
                    setStepCurrentPosition(1);
                    setSending(false);
                    setRedirectCount(8);
                    setRedirectIsCounting(true);
                    // navigate(`/${hotel.code}/checkin/status`)
                })
                .catch((err) => {
                    console.log('17sep - sendToValidate - error', err)
                    setSending(false);
                    // console.log("0210 err", err);
                });
        }
    };

    const doRate = useCallback((value) => {
        rate(value);
    });

    const goPrev = useCallback(() => {
        setStepError(false)
        setStepCurrentPosition(stepCurrentPosition - 1);
        ScreenComponent.current.scrollToTop();
        // ScreenComponent.current.forceCheckHeightPage();
    }, [stepCurrentPosition]);

    useEffect(() => {

        if (paymentComponentVersion === "v1") {

            setPaymentError(null);

            if (paymentState != "no-payment-pending" && paymentState != "done" && paymentState != "error") {
                setPaymentState('initial');
            }

            setNextDisabled(false);
            console.log('stepCurrentPosition paymentState', paymentState);
            if (!paymentOmmited) {
                // TODO_G: 2025-06-10 Se quitó el habilitar cuando hay un error en el pago
                // if (currentStep == "payment" && (paymentState != "no-payment-pending" && paymentState != "done" && paymentState != "error")) {
                if (currentStep === "payment" && (paymentState !== "no-payment-pending" && paymentState !== "done")) {
                    setNextDisabled(true);
                }
            }

            // if (stepCurrentPosition === 3) {
            //   setPaymentState('loading-balance');
            //   getBalance().then(r => {
            //     setPaymentState('show-balance');
            //     setBalance(r)
            //   })
            // }
        }

    }, [stepCurrentPosition, paymentOmmited])

    const steps = useMemo(() => {

        const _steps = [];
        let _step = 0;
        _steps.push({ label: T('general.guests'), key: "guests", step: ++_step });

        if (!isHostzBetaHouse(hotel.id) && !isHostzSteiners(hotel.id) && !isHostzSwissstay(hotel.id)) {
            _steps.push({
                label: isHostz(hotel.id) ? T('general.interests_hostz') : isOffgrid(hotel.id) ? T('general.interests_offgrid') : T('general.interests'),
                key: "interests",
                step: ++_step
            });
        }

        if (account?.steps) {
            // Existe steps -> decide
            if (account.steps.addons?.show && (filteredCupsList && filteredCupsList.length > 0)) {
                _steps.push({ label: T('cups.title'), key: "cups", step: ++_step });
            }
            if (!isKioskMode && account.steps.payments?.show) {
                _steps.push({ label: T('general.payments'), key: "payment", step: ++_step });
            } else {
                if (!isKioskMode && showPaymentByUpselling) {
                    setOnlyPaymentsByUpselling(true);
                    _steps.push({ label: T('general.payments'), key: "payment", step: ++_step });
                }
            }

        } else {
            // No existe steps -> modo compatibilidad => Borrar en breve
            if (!isHostzBetaHouse(hotel.id)) {
                if (filteredCupsList && filteredCupsList.length > 0) {
                    _steps.push({ label: T('cups.title'), key: "cups", step: ++_step });
                }
            }
            if (!isKioskMode && account?.gateway?.partner === "adyen") {
                _steps.push({ label: T('general.payments'), key: "payment", step: ++_step });
            }

        }

        _steps.push({
            label: isOffgrid(hotel.id) ? T('general.summary_offgrid') : T('general.summary'),
            key: "summary",
            step: ++_step
        });

        // const steps = [
        //   // { label: T('general.reservation'), step: 1 },
        //   { label: T('general.guests'), step: 1 },
        //   // { label: T('general.guests'), step: 2 },
        //   { label: T('general.interests'), step: 2 },
        //   { label: 'Payments', step: 3 },
        //   { label: T('general.summary'), step: 4 }
        // ]

        return _steps;

    }, [account, filteredCupsList, showPaymentByUpselling, isKioskMode]);

    const loading = useMemo(() => {
        let _loading_completed = true;
        _loading_completed = _loading_completed && checkIn && Object.keys(checkIn).length > 0;
        _loading_completed = _loading_completed && account !== null;
        _loading_completed = _loading_completed && upsellingsLoaded;
        _loading_completed = _loading_completed && steps && steps.length > 0;

        // console.log("LOADING --- checkIn", checkIn && Object.keys(checkIn).length > 0)
        // console.log("LOADING --- account", account !== null)
        // console.log("LOADING --- upsellingsLoaded", upsellingsLoaded)
        // console.log("LOADING --- steps", steps && steps.length > 0)

        return !(_loading_completed);
    }, [checkIn, account, upsellingsLoaded, steps])

    const currentStep = useMemo(() => {
        return (steps[stepCurrentPosition - 1] && steps[stepCurrentPosition - 1].key) || false;
    }, [steps, stepCurrentPosition])

    // Notificar al contexto cuando entra/sale del paso de payment
    useEffect(() => {
        console.log('4dic2 - **** - useEffect - currentStep', currentStep);
        if (currentStep === "payment") {

            if (paymentComponentVersion !== "v1") {
                paymentSetCart(cartNew);
                setActive(true);
                setNextDisabled(!allowSkipPayment);
            }


        } else {
            setNextDisabled(false);
            setActive(false);
        }
    }, [currentStep, allowSkipPayment]);

    useEffect(() => {
        if (paymentComponentVersion === "v2" && paymentStatus === PAYMENT_STATUSES.PAYMENT_FAILED && paymentLastError) {
            setPaymentError(paymentLastError);
        }
        if (paymentComponentVersion === "v2" && paymentStatus === PAYMENT_STATUSES.PAYMENT_OK) {
            setPaymentError(null);
        }
    }, [paymentComponentVersion, paymentStatus, paymentLastError]);

    useEffect(() => {
        console.log('4dic2 - **** - useEffect - cartNew', cartNew);
        if (paymentComponentVersion !== "v1" && currentStep === "payment") {
            paymentSetCart(cartNew);
        }
    }, [cartNew, currentStep]);

    useEffect(() => {
        console.log('1dic - **** - currentStep', currentStep);
        console.log('1dic - **** - AAA - paymentCheckoutRef', paymentCheckoutRef.current);
        if (currentStep === "payment") {
            if (paymentCheckoutRef?.current) {
                setPaymentCheckoutRef(paymentCheckoutRef.current);
                console.log('1dic *** - AAA - setPaymentCheckoutRef', paymentCheckoutRef.current);
            } else {
                setTimeout(() => {
                    if (paymentCheckoutRef?.current) {
                        setPaymentCheckoutRef(paymentCheckoutRef.current);
                        console.log('1dic - **** - BBB - setPaymentCheckoutRef after timeout', paymentCheckoutRef.current);
                    }
                }, 500);
            }
        }
        // else {
        //     // Si el ref está null, intentar encontrarlo en el DOM directamente
        //     console.log('**28nov** - REF es NULL, buscando en DOM...');
        //     const element = document.querySelector('.payment[ref]') || document.querySelector('div.payment');
        //     if (element) {
        //         console.log('**28nov** - ENCONTRADO en DOM, reasignando', element);
        //         paymentCheckoutRef.current = element;
        //         setPaymentCheckoutRef(element);
        //     }
        // }
    }, [paymentCheckoutRef?.current, currentStep]);

    // Efecto adicional que vigila si el ref se vuelve disponible después de un redirect
    // useEffect(() => {
    //     if (currentStep === "payment" && !paymentCheckoutRef?.current) {
    //         const checkInterval = setInterval(() => {
    //             if (paymentCheckoutRef?.current) {
    //                 console.log('**28nov** - REF RECOVERED after redirect!');
    //                 setPaymentCheckoutRef(paymentCheckoutRef.current);
    //                 clearInterval(checkInterval);
    //             }
    //         }, 100);
    //         return () => clearInterval(checkInterval);
    //     }
    // }, [currentStep]);

    const goNext = useCallback(() => {
        // if (stepCurrentPosition === 1) {
        //   setStepCurrentPosition(2);
        //   ScreenComponent.current.scrollToTop();
        //   // ScreenComponent.current.forceCheckHeightPage();
        //   // if (validateAt('travelType')) {
        //   //   resetErrors();
        //   //   setStepCurrentPosition(2);
        //   // } else {
        //   //   validate();
        //   // }
        // }
        // console.log('2912 - currentStep', currentStep)

        if (currentStep === "guests") {
            const isPassengersValid = validateAt("passengers");
            const isEmailValid = validateAt("email");
            const isPhoneValid = validateAt("phone");
            console.log('2912 - checkIn.linked_checkins', checkIn.linked_checkins)
            let isLinkedCheckInsPassengersValid = true;
            if (checkIn.linked_checkins?.length > 0) {
                isLinkedCheckInsPassengersValid = validateAt("linked_checkins");
                console.log('2912 - isLinkedCheckInsPassengersValid', isLinkedCheckInsPassengersValid)
            } else {
                isLinkedCheckInsPassengersValid = true;
            }

            if (isPassengersValid && isEmailValid && isPhoneValid && isLinkedCheckInsPassengersValid) {
                resetErrors();
                setStepError(false);
                setStepCurrentPosition(stepCurrentPosition + 1);
                ScreenComponent.current.scrollToTop();
            } else {
                setStepError({
                    email: !isEmailValid ? "yup.required" : "",
                    phone: !isPhoneValid ? "yup.required" : "",
                });
                validate();
            }
        }
        if (currentStep === "interests") {
            let _hasError = false;
            let _stepErrors = {};
            if (isSimplex(hotel.id)) {
                if (!validateAt("entryTime")) {
                    _hasError = true;
                    _stepErrors["entryTime"] = "yup.required";
                }
            }
            if (!isHostzBlackSummit(hotel.id) && !isHostzSwissstay(hotel.id)) {
                _hasError = _hasError || !validateAt("travelType");
                _stepErrors["travelType"] = "yup.required";
            }
            if (isHostzBlackSummit(hotel.id)) {
                if (!validateAt("entryTime")) {
                    _hasError = true;
                    _stepErrors["entryTime"] = "yup.required";
                }
                if (!validateAt("arrivalMode")) {
                    _hasError = true;
                    _stepErrors["arrivalMode"] = "yup.required";
                }
                console.log('20ene - extraData.qtyAdults', validateAt("extraData.qtyAdults"))
                if (!validateAt("extraData.qtyAdults")) {
                    _hasError = true;
                    _stepErrors["extraData_qtyAdults"] = "yup.required";
                }
                if (!validateAt("extraData.qtyChild")) {
                    _hasError = true;
                    _stepErrors["extraData_qtyChild"] = "yup.required";
                }
                if (!validateAt("extraData.qtyBabies")) {
                    _hasError = true;
                    _stepErrors["extraData_qtyBabies"] = "yup.required";
                }
            }
            if (!_hasError) {
                resetErrors();
                setStepError(false)
                setStepCurrentPosition(stepCurrentPosition + 1);
                ScreenComponent.current.scrollToTop();
            } else {
                // setStepError({
                //   travelType: "yup.required"
                // })
                setStepError(_stepErrors)
                validate();
            }
        }
        if (currentStep === "cups") {
            setStepCurrentPosition(stepCurrentPosition + 1);
            ScreenComponent.current.scrollToTop();
        }
        if (currentStep === "payment") {
            if (paymentComponentVersion === "v1") {
                console.log('1dic - paymentState', paymentState);
                if (!paymentOmmited && (paymentState !== 'no-payment-pending' && paymentState !== 'done' && paymentState !== 'error')) {
                    setPaymentError('Payment is Required')
                    return;
                }
            } else {
                if (!allowSkipPayment) {
                    setPaymentError('Payment is Required')
                    return;
                }
            }

            setStepCurrentPosition(stepCurrentPosition + 1);
            ScreenComponent.current.scrollToTop();
        }
        // setStepCurrentPosition(stepCurrentPosition+1)
    }, [currentStep, stepCurrentPosition, checkIn, paymentState, paymentOmmited, allowSkipPayment]);

    const SignModal = () => {
        const [uploading, setUploading] = useState(false)
        return (
            <Modal 
                show={showSignModal} 
                onHide={() => setShowSignModal(false)} 
                closeButton
                dialogClassName={isKioskMode ? 'kiosk-signature-modal' : ''}
                centered
            >
                <Modal.Header>
                    <Modal.Title>{T("checkin.please-sign-below")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: "center" }}>
                        <SignatureCanvas 
                            ref={(ref) => { signCanvas = ref }} 
                            penColor='black' 
                            canvasProps={{ 
                                width: 400, 
                                height: 350, 
                                className: 'checkin-sign'
                            }} 
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {uploading && (<div className="loading text-center w-100">
                        <div className="spinner-border"></div>
                    </div>)}
                    {!uploading && (<>
                        <Button 
                            variant="secondary" 
                            onClick={() => setShowSignModal(false)}
                            className={isKioskMode ? '' : ''}
                        >
                            {T("general.go-back")}
                        </Button>

                        <Button 
                            variant="secondary" 
                            onClick={() => {
                                signCanvas.clear();
                            }}
                        >
                            {T("general.clear")}
                        </Button>
                        <Button 
                            type={"button"} 
                            className={`btn-accept ${isKioskMode ? '' : ''}`}
                            variant={"secondary"}
                            onClick={() => {
                                if (!signCanvas.isEmpty()) {
                                    setUploading(true);
                                    const dataUrl = signCanvas.getTrimmedCanvas().toDataURL('image/png');
                                    var fileName =
                                        checkIn.id +
                                        "_sign_" +
                                        Date.now() +
                                        ".png";

                                    Storage.put(fileName, dataURLtoBlob(dataUrl)).then((res) => {
                                        // setSigning(false)
                                        setSign(res["key"])
                                        setShowSignModal(false)
                                        // validate()
                                    });
                                } else {
                                    alert(T('checkin.signature-empty'))
                                }
                            }}
                        >
                            {T("general.confirm")}
                        </Button>
                    </>)}

                </Modal.Footer>
            </Modal>
        );
    };

    const renderName = (age) => {
        let res = T("checkin.child");
        if (age) {
            res += ` (${age} ${T("checkin.years")}) `;
        }
        return res;
    }

    // const paymentResult = (res, detail) => {
    //     console.log('paymentResult - res', res);
    //     console.log('paymentResult - detail', detail);

    //     if (res == 'Loading') {
    //         console.log('setPaymentState', 'loading-component');
    //         setPaymentState('loading-component');
    //     }
    //     if (res == 'InProgress') {
    //         console.log('setPaymentState', 'in-progress');
    //         setPaymentState('in-progress');
    //     }
    //     if (res == 'Authorised') {
    //         console.log('setPaymentState', 'done');
    //         setPaymentState('done');
    //         setNextDisabled(false);
    //     }
    //     if (res == 'Refused' || res == 'Error') {
    //         console.log('setPaymentState', 'error');
    //         setPaymentState('error');
    //         setNextDisabled(false);
    //     }

    // }

    const addToCart = (id) => {
        console.log('addToCart', id);

        let auxCart = [...cartNew];
        if (!auxCart.includes(id)) {
            // Si el valor no está, se agrega
            auxCart.push(id);
            setCartNew(auxCart);
        }
    }
    const removeToCart = (id) => {
        console.log('removeToCart', id);

        let auxCart = [...cartNew];
        if (auxCart.includes(id)) {
            // Si el valor está en el array, se elimina
            auxCart = auxCart.filter(item => item !== id);
            setCartNew(auxCart);
        }
    }

    const showPaymentComponent = useMemo(() => {
        let show = (currentStep == "payment");
        show = show && ((paymentState == "in-progress") || (paymentState == "error") || (paymentState == "done"));
        return show;
    }, [currentStep, paymentState])


    const handleChangePaymentState = (state) => {
        console.log('handleChangePaymentState', state);
        if (state == "no-payment-pending") {
            setNextDisabled(false);
            setPaymentState("no-payment-pending");
        }
        if (state == "done") {
            setNextDisabled(false);
            setPaymentState("done");
        }
        if (state == "error") {
            // TODO_G: 2025-06-10 Se quitó el habilitar cuando hay un error en el pago
            // setNextDisabled(false);
            setPaymentError(null); // TODO_G: Ver de conseguir el detalle del error
        }
        if (state == "loading-component") {
            setNextDisabled(true);
            setPaymentError(null);
        }
    }
    const handleChangeOmmited = (value) => {
        setPaymentOmmited(value);
    }

    if (loading) {
        const loadingScreen = <Screen
            hideHeader={isKioskMode}
            section={"checkin-detail"}
            title={i18nValue(sectionsByCode['fast_checkin'], 'title', language) || "Check-In"}
            classes={isKioskMode ? 'kiosk-loading-screen' : ''}
            >
            
            <div>
                <Player
                    autoplay={true}
                    loop={true}
                    keepLastFrame={true}
                    src="/lottie/webcheckin-loading.json"
                    style={{ height: isKioskMode ? '350px' : '500px', width: '100%' }}
                ></Player>
                <h5 className="text-center font-weight-bold mb-1">{T("checkin.checkin.preparing-title")}</h5>
                <p className="mt-2 text-center font-size-sm text-muted">{T("checkin.checkin.preparing-text")}</p>
            </div>
        </Screen>
        
        if (isKioskMode) {
            return (
                <div className="kiosk-checkin-wrapper">
                    <div className="kiosk-checkin-container">
                        {loadingScreen}
                    </div>
                </div>
            )
        }
        
        return loadingScreen;
    }

    // console.log("***29nov** - CheckInDetailNew - stepCurrentPosition", stepCurrentPosition);
    // console.log("***29nov** - CheckInDetailNew - paymentComponentVersion", paymentComponentVersion);
    // console.log("***29nov** - CheckInDetailNew - steps", steps);

    const screenContent = (
        <Screen
            section={"checkin-detail"}
            classes={"scr__een-flex"}
            title={i18nValue(sectionsByCode['fast_checkin'], 'title', language) || "Check-In"}
            headerContent={headerInfo}
            ref={ScreenComponent}
            backUrl={stepCurrentPosition === 1 ? `./checkin/status` : null}
            onBackClick={() => {
                if (editMode) {
                    if (stepCurrentPosition > 1) {
                        goPrev();
                        return true;
                        // } else if (checkIn.status !== "pending" && checkIn.status !== "in_stay") {
                        //   // setEditMode(false);
                        //   // return true;
                    }
                }
            }}
            hideHeader={isKioskMode}
        >
            {!isKioskMode && editMode && stepCurrentPosition < steps.length && <div className="checkin-header bg-white" style={{ margin: "-10px -15px -26px -15px", paddingBottom: 35 }}>
                <CheckInHeader />
            </div>}
            {editMode && <ProgressSteps steps={steps} activeStep={stepCurrentPosition} />}
            <div className="vico-form-container">

                {!sending && !editMode && checkIn.status === "to_validate" && (
                    <div
                        className="card-status text-center mb-2"
                        style={{
                            background: "white",
                            border: "1px solid #EEE",
                            borderRadius: 10,
                            padding: "10px 20px",
                            marginTop: 80
                        }}
                    >
                        {checkIn.status === "to_validate" && <>
                            <span className="font-size-sm d-block">
                                <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 120, color: '#28a745', marginTop: -50 }} className="mb-1" />
                            </span>
                            <p style={{ fontSize: "1.1rem" }} className="mt-2 mb-2">
                                {T(`checkin.status-${checkIn.status}-text`)}
                            </p>
                        </>}
                    </div>
                )}

                {sending && (
                    <div className="loading text-center mt-5">
                        <div className="spinner-border" role="status"></div>
                    </div>
                )}

                {
                    editMode && !sending && currentStep === "guests" && (
                        <>
                            <h5 className="text-subtitle mt-5 text-center">
                                {T("checkin.e-mail")}
                            </h5>
                            <Form.Control
                                type={"input"}
                                autoComplete="email"
                                value={checkIn.email}
                                onChange={(event) => {
                                    setEmail(String(event.target.value).toLowerCase());
                                }}
                                isInvalid={errors.email}
                            />
                            {errors.email && (
                                <Form.Control.Feedback type="invalid">
                                    {T(errors.email)}
                                </Form.Control.Feedback>
                            )}

                            {/* Comienza telefono */}

                            <h5 className="text-subtitle mt-3 text-center">
                                {T("checkin.phone")}
                            </h5>

                            <Form.Group controlId="phone" autoComplete="tel" type={"input"}>
                                <PhoneInputI18n
                                    phone={checkIn.phone}
                                    language={language}
                                    onSelect={setPhone}
                                    isInvalid={errors.phone}
                                />
                                {errors.phone && (
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {T(errors.phone)}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>

                            {/* <Form.Control
              type={"input"}
              value={checkIn.phone}
              onChange={(event) => {
                setPhone(event.target.value);
              }}
              isInvalid={errors.phone}
            /> 
            {errors.phone && (
              <Form.Control.Feedback type="invalid">
                {T(errors.phone)}
              </Form.Control.Feedback>
            )}*/}


                            {/* Termina telefono */}


                            <h5 className="text-subtitle mt-3 text-center">
                                {T("checkin.guest-data")}
                            </h5>
                            {editMode && (
                                <p className="general-text-sm text-center">
                                    {T("checkin.guest-data-text")}
                                </p>
                            )}

                            {checkIn.passengers && checkIn.passengers.map((p, idx) => <PassengerItemComponent
                                passenger={p}
                                idx={idx}
                                checkIn={checkIn}
                                editMode={editMode}
                                errors={errors}
                                setPassengerOmmit={setPassengerOmmit}
                            />)}

                            {checkIn.linked_checkins && checkIn.linked_checkins.map((linked_checkin, linked_checkin_idx) => <>
                                <h6 className="text-subtitle mt-4 mb-3 text-center">
                                    {T('checkin.room')} {linked_checkin_idx + 2}
                                </h6>
                                {linked_checkin.passengers && linked_checkin.passengers.map((p, idx) => <PassengerItemComponent
                                    key={`row-passenger-${linked_checkin_idx}-${idx}`}
                                    passenger={p}
                                    linked_checkin_idx={linked_checkin_idx}
                                    idx={idx}
                                    checkIn={checkIn}
                                    editMode={editMode}
                                    errors={errors}
                                    setPassengerOmmit={(idx, value) => {
                                        console.log('28dic - linked_chackin_idx', linked_checkin_idx)
                                        console.log('28dic - idx', idx)
                                        console.log('28dic - value', value)
                                        setPassengerLinkedCheckinOmmit(linked_checkin_idx, idx, value)
                                    }}
                                />
                                )}
                            </>)}





                        </>
                    ) /* End step 2 */
                }

                {
                    editMode && !sending && currentStep === "interests" && (
                        <>
                        {!isHostzSwissstay(hotel.id) && (
                          <>
                            <h5 className="text-subtitle mt-3 text-center">
                                {T("checkin.type-of-travel")}
                            </h5>

                            <p className="general-text-sm text-center">
                                {T("checkin.type-of-travel-text")}
                            </p>


                            <Form.Control
                                as={"select"}
                                value={checkIn.travelType ?? null}
                                placeholder={T("checkin.travel-type")}
                                onChange={(event) => {
                                    setTravelType(event.target.value);
                                    errors.travelType = ""
                                    event.target.value !== "" && setStepError(false)
                                }}
                                isInvalid={stepError.travelType}
                                required
                            >

                                <option value={""}>{T("select...")}</option>
                                {isHostzSwissstay(hotel.id) && (
                                    <>
                                        <option value="business">{T("checkin.travel-type.business")}</option>
                                        <option value="leisure">{T("checkin.travel-type.leisure")}</option>
                                    </>
                                )}

                                {!isHostzSwissstay(hotel.id) && (
                                    <>
                                        <option value="couple">{T("checkin.travel-type.couple")}</option>
                                        <option value="family">{T("checkin.travel-type.family")}</option>
                                        {(!isOffgrid(hotel.id)) && <option value="business">
                                            {T("checkin.travel-type.business")}
                                        </option>}
                                        {(!isOffgrid(hotel.id) && !isHostz(hotel.id)) && <option value="congress">
                                            {T("checkin.travel-type.congress")}
                                        </option>}
                                        {(!isHostz(hotel.id) && !isOffgrid(hotel.id)) && <option value="event">{T("checkin.travel-type.event")}</option>}
                                        <option value="friends">
                                            {T("checkin.travel-type.friends")}
                                        </option>
                                        {(!isHostz(hotel.id)) && <option value="relaxing">
                                            {T("checkin.travel-type.relaxing")}
                                        </option>}
                                        {(!isHostz(hotel.id) && !isOffgrid(hotel.id)) && <option value="party">{T("checkin.travel-type.party")}</option>}
                                        {(!isHostz(hotel.id)) && <option value="single_traveler"> {T("checkin.travel-type.single_traveler")} </option>}
                                    </>
                                )}
                            </Form.Control>
                            </>
                        )}
                            {!isHostzBlackSummit(hotel.id) && !stepError.travelType && checkIn.travelType === "" && <div
                                className="text-danger d-flex justify-content-end"
                                style={{ position: "relative", width: "10px", left: "90%", bottom: 26 }}
                            >
                                *
                            </div>
                            }
                            {stepError.travelType && (
                                <Form.Control.Feedback type="invalid">
                                    {T(stepError.travelType)}
                                </Form.Control.Feedback>
                            )}

                            {(!isHostzMyde(hotel.id) && !isHostzSwissstay(hotel.id) && !isHostzSteiners(hotel.id)) && !isKioskMode && (
                                <>
                                    <hr />
                                    <h5 className="text-subtitle text-center">
                                        {T("checkin.time-of-arrival")}
                                    </h5>
                                    <p className="general-text-sm text-center">
                                        {T("checkin.time-of-arrival-text")}
                                    </p>
                                    <Form.Control
                                        as={"select"}
                                        value={checkIn?.entryTime}
                                        placeholder={T("checkin.entry-time")}
                                        onChange={(event) => {
                                            setEntryTime(event.target.value);
                                        }}
                                        isInvalid={stepError.entryTime}
                                    >
                                        <option value="">{T("select...")}</option>
                                        <option value="0">0{T("general.hs")}</option>
                                        <option value="1">1{T("general.hs")}</option>
                                        <option value="2">2{T("general.hs")}</option>
                                        <option value="3">3{T("general.hs")}</option>
                                        <option value="4">4{T("general.hs")}</option>
                                        <option value="5">5{T("general.hs")}</option>
                                        <option value="6">6{T("general.hs")}</option>
                                        <option value="7">7{T("general.hs")}</option>
                                        <option value="8">8{T("general.hs")}</option>
                                        <option value="9">9{T("general.hs")}</option>
                                        <option value="10">10{T("general.hs")}</option>
                                        <option value="11">11{T("general.hs")}</option>
                                        <option value="12">12{T("general.hs")}</option>
                                        <option value="13">13{T("general.hs")}</option>
                                        <option value="14">14{T("general.hs")}</option>
                                        <option value="15">15{T("general.hs")}</option>
                                        <option value="16">16{T("general.hs")}</option>
                                        <option value="17">17{T("general.hs")}</option>
                                        <option value="18">18{T("general.hs")}</option>
                                        <option value="19">19{T("general.hs")}</option>
                                        <option value="20">20{T("general.hs")}</option>
                                        <option value="21">21{T("general.hs")}</option>
                                        <option value="22">22{T("general.hs")}</option>
                                        <option value="23">23{T("general.hs")}</option>
                                        {isHostz(hotel.id) && (<option value="99">{T("checkin.entry-time-not-know-yet")}</option>)}
                                    </Form.Control>
                                    {isHostzBlackSummit(hotel.id) && !stepError.entryTime && <div
                                        className="text-danger d-flex justify-content-end"
                                        style={{ position: "relative", width: "10px", left: "90%", bottom: 26 }}
                                    >
                                        *
                                    </div>
                                    }
                                    {stepError.entryTime && (
                                        <Form.Control.Feedback type="invalid">
                                            {T(stepError.entryTime)}
                                        </Form.Control.Feedback>
                                    )}
                                    {!isBelAir(hotel.id) && (
                                        <GetCheckinTime hotelId={hotel.id} />
                                    )}
                                </>
                            )}

                            {(!isHostzMyde(hotel.id) && !isHostzSwissstay(hotel.id) && !isHostzSteiners(hotel.id)) && (
                                <>
                                    <hr />
                                    <h5 className="text-subtitle mt-3 text-center">
                                        {T(isHostz(hotel.id) ? "checkin.arrivalMode-hostz" : "checkin.arrivalMode")}
                                    </h5>
                                    <p className="general-text-sm text-center">
                                        {T("checkin.arrivalMode-text")}
                                    </p>
                                    <Form.Control
                                        as={"select"}
                                        value={checkIn.arrivalMode ?? null}
                                        placeholder={T("checkin.arrivalMode")}
                                        onChange={(event) => {
                                            setArrivalMode(event.target.value);
                                        }}
                                        isInvalid={stepError.arrivalMode}
                                    >
                                        <option value={""}>{T("select...")}</option>
                                        <option value="airplane">{T("checkin.arrivalMode.airplane")}</option>

                                        {isHostzBlackSummit(hotel.id) && <option value="public_transportation">{T("checkin.arrivalMode.public_transportation")}</option>}
                                        {!isHostzBlackSummit(hotel.id) && <option value="train">{T("checkin.arrivalMode.train")}</option>}
                                        {!isHostzBlackSummit(hotel.id) && <option value="bus">{T("checkin.arrivalMode.bus")}</option>}

                                        <option value="car">{T("checkin.arrivalMode.car")}</option>
                                        <option value="other">{T("checkin.arrivalMode.other")}</option>
                                    </Form.Control>
                                    {isHostzBlackSummit(hotel.id) && !stepError.extraData_qtyAdults && <div
                                        className="text-danger d-flex justify-content-end"
                                        style={{ position: "relative", width: "10px", left: "90%", bottom: 26 }}
                                    >
                                        *
                                    </div>
                                    }
                                    {stepError.arrivalMode && (
                                        <Form.Control.Feedback type="invalid">
                                            {T(stepError.arrivalMode)}
                                        </Form.Control.Feedback>
                                    )}
                                </>
                            )}

                            {showCarOptions && <>
                                <Row>
                                    <Col xs={6} className={"pr-1"}>
                                        <h6
                                            className="general-text-sm text-center mt-2"
                                        >
                                            Traditional
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["qtyCarICE"]
                                                    : null
                                            }
                                            onChange={(event) => {
                                                setExtraData("qtyCarICE", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="1">{1}</option>
                                            <option value="2">{2}</option>
                                            <option value="3">{3}</option>
                                        </Form.Control>
                                    </Col>
                                    <Col xs={6} className={"pl-1"}>
                                        <h6
                                            className="general-text-sm text-center mt-2"
                                        >
                                            Electric
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["qtyCarElectric"]
                                                    : null
                                            }
                                            onChange={(event) => {
                                                setExtraData("qtyCarElectric", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="1">{1}</option>
                                            <option value="2">{2}</option>
                                            <option value="3">{3}</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </>}

                            {/* <hr />
            <h5 className="text-subtitle mt-3 text-center">
              {T("checkin.room-preferences")}
            </h5>
            <p className="general-text-sm text-center">
              {T("checkin.room-preferences-text")}
            </p>
            <Form.Control
              as={"select"}
              value={
                checkIn.extraData ? checkIn.extraData["roomPreference"] : null
              }
              placeholder={T("checkin.room-preference")}
              onChange={(event) => {
                setExtraData("roomPreference", event.target.value);
              }}
            >
              <option value="">{T("select...")}</option>
              <option value="close-to-elevator">
                {T("checkin.room-preferences.close-to-elevator")}
              </option>
              <option value="far-from-elevator">
                {T("checkin.room-preferences.far-from-elevator")}
              </option>
              <option value="wheelchair-accessible">
                {T("checkin.room-preferences.wheelchair-accessible")}
              </option>
              <option value="lower-floor">
                {T("checkin.room-preferences.lower-floor")}
              </option>
              <option value="higher-floor">
                {T("checkin.room-preferences.higher-floor")}
              </option>
            </Form.Control> */}

                            <hr />

                            {isHostzBlackSummit(hotel.id) && <>
                                <h5 className="text-subtitle mt-3 text-center">
                                    {T("general.guests")}
                                </h5>
                                <p className="general-text-sm text-center">
                                    {T("checkin.guests-text")}
                                </p>
                                <Row>
                                    <Col xs={4} className={"pr-1"}>
                                        <h6
                                            className="general-text-sm text-center mt-2"
                                        >
                                            {T("checkin.adults")}
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["qtyAdults"]
                                                    : null
                                            }
                                            onChange={(event) => {
                                                setExtraData("qtyAdults", event.target.value);
                                            }}
                                            isInvalid={stepError.extraData_qtyAdults}
                                        >
                                            <option value="">{T("select...")}</option>
                                            {/* <option value="0">{0}</option> */}
                                            <option value="1">{1}</option>
                                            <option value="2">{2}</option>
                                            <option value="3">{3}</option>
                                            <option value="4">{4}</option>
                                            <option value="5">{5}</option>
                                            <option value="6">{6}</option>
                                            <option value="7">{7}</option>
                                            <option value="8">{8}</option>
                                            <option value="9">{9}</option>
                                            <option value="10">{10}</option>
                                            <option value="11">{11}</option>
                                            <option value="12">{12}</option>
                                            <option value="13">{13}</option>
                                            <option value="14">{14}</option>
                                        </Form.Control>
                                        {isHostzBlackSummit(hotel.id) && !stepError.extraData_qtyAdults && <div
                                            className="text-danger d-flex justify-content-end"
                                            style={{ position: "relative", width: "10px", left: "68%", bottom: 26 }}
                                        >
                                            *
                                        </div>
                                        }
                                        {stepError.extraData_qtyAdults && (
                                            <Form.Control.Feedback type="invalid">
                                                {T(stepError.extraData_qtyAdults)}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                    <Col xs={4} className={""}>
                                        <h6
                                            className="general-text-sm text-center mt-2"
                                        >
                                            {T("checkin.children")}
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["qtyChild"]
                                                    : null
                                            }
                                            isInvalid={stepError.extraData_qtyChild}
                                            onChange={(event) => {
                                                setExtraData("qtyChild", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="0">{0}</option>
                                            <option value="1">{1}</option>
                                            <option value="2">{2}</option>
                                            <option value="3">{3}</option>
                                            <option value="4">{4}</option>
                                            <option value="5">{5}</option>
                                            <option value="6">{6}</option>
                                            <option value="7">{7}</option>
                                            <option value="8">{8}</option>
                                            <option value="9">{9}</option>
                                            <option value="10">{10}</option>
                                        </Form.Control>
                                        {isHostzBlackSummit(hotel.id) && !stepError.extraData_qtyChild && <div
                                            className="text-danger d-flex justify-content-end"
                                            style={{ position: "relative", width: "10px", left: "68%", bottom: 26 }}
                                        >
                                            *
                                        </div>
                                        }
                                        {stepError.extraData_qtyChild && (
                                            <Form.Control.Feedback type="invalid">
                                                {T(stepError.extraData_qtyChild)}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                    <Col xs={4} className={"pl-1"}>
                                        <h6
                                            className="general-text-sm text-center mt-2"
                                        >
                                            {T("checkin.babies")}
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["qtyBabies"]
                                                    : null
                                            }
                                            isInvalid={stepError.extraData_qtyBabies}
                                            onChange={(event) => {
                                                setExtraData("qtyBabies", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="0">{0}</option>
                                            <option value="1">{1}</option>
                                            <option value="2">{2}</option>
                                            <option value="3">{3}</option>
                                            <option value="4">{4}</option>
                                            <option value="5">{5}</option>
                                        </Form.Control>
                                        {isHostzBlackSummit(hotel.id) && !stepError.extraData_qtyBabies && <div
                                            className="text-danger d-flex justify-content-end"
                                            style={{ position: "relative", width: "10px", left: "68%", bottom: 26 }}
                                        >
                                            *
                                        </div>
                                        }
                                        {stepError.extraData_qtyBabies && (
                                            <Form.Control.Feedback type="invalid">
                                                {T(stepError.extraData_qtyBabies)}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                </Row>
                                <hr />
                            </>}

                            {(hotel && hotel.id === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516" || hotel && hotel.id === "511e8df9-672d-42b1-9711-d82beb7baf64") && !isKioskMode && (
                                <>
                                    <h5 className="text-subtitle mt-3 text-center">
                                        {T("checkin.floor-selection")}
                                    </h5>
                                    {/*  <p className="general-text-sm text-center">
                  {T("checkin.floor-selection-text")}
                </p> */}
                                    <div className="text-center">
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["floorSelection"]
                                                    : null
                                            }
                                            placeholder={T("checkin.floor-selection")}
                                            onChange={(event) => {
                                                setExtraData("floorSelection", event.target.value);
                                            }}
                                            isInvalid={errors.floorSelection}
                                        >
                                            <option value={""}>{T("select...")}</option>
                                            <option value="gf">{T("checkin.ground-floor")}</option>
                                            <option value="indifferent">{T("checkin.indifferent")}</option>
                                        </Form.Control>
                                        {errors.floorSelection && (
                                            <Form.Control.Feedback type="invalid" className="d-block">
                                                {T(errors.floorSelection)}
                                            </Form.Control.Feedback>
                                        )}
                                    </div>
                                    <hr />
                                </>
                            )}



                            {/* Castaño,Ferien,Kalm exlcuidos */}
                            {hotel && hotel.id && showHouseKeeping(hotel.id) && <>
                                <h5 className="text-subtitle mt-3 text-center">
                                    {T("checkin.take-care-environment")}
                                </h5>
                                <p className="general-text-sm text-center">
                                    {T("checkin.take-care-environment-text")}
                                </p>
                                <Row>
                                    <Col xs={6} className={"pr-1"}>
                                        <h6
                                            className="general-text-sm text-center"
                                            style={{
                                                height: 40,
                                                display: "table-cell",
                                                verticalAlign: "middle",
                                            }}
                                        >
                                            {T("checkin.take-care-environment.housekeeping-frequency")}
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["cleaningFrequency"]
                                                    : null
                                            }
                                            placeholder={T("checkin.cleaning-frequency")}
                                            onChange={(event) => {
                                                setExtraData("cleaningFrequency", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="clean-do-not-clean">
                                                {T(
                                                    "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room"
                                                )}
                                            </option>
                                            <option value="clean-every-other-day">
                                                {T(
                                                    "checkin.take-care-environment.housekeeping-frequency.every-other-day"
                                                )}
                                            </option>

                                            <option value="clean-everyday">
                                                {T(
                                                    "checkin.take-care-environment.housekeeping-frequency.everyday"
                                                )}
                                            </option>
                                        </Form.Control>
                                    </Col>
                                    <Col xs={6} className={"pl-1"}>
                                        <h6
                                            className="general-text-sm text-center"
                                            style={{
                                                height: 40,
                                                display: "table-cell",
                                                verticalAlign: "middle",
                                            }}
                                        >
                                            {T(
                                                "checkin.take-care-environment.towell-replacement-frequency"
                                            )}
                                        </h6>
                                        <Form.Control
                                            as={"select"}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["towelChangeFrequency"]
                                                    : null
                                            }
                                            placeholder={T("checkin.towel-change-frequency")}
                                            onChange={(event) => {
                                                setExtraData("towelChangeFrequency", event.target.value);
                                            }}
                                        >
                                            <option value="">{T("select...")}</option>
                                            <option value="towel-do-not-change">
                                                {T(
                                                    "checkin.take-care-environment.towell-replacement-frequency.do-not-change"
                                                )}
                                            </option>
                                            {/* <option value="towel-change-daily">
                    {T(
                      "checkin.take-care-environment.towell-replacement-frequency.everyday"
                    )}
                  </option> */}
                                            <option value="towel-change-every-other-day">
                                                {T(
                                                    "checkin.take-care-environment.towell-replacement-frequency.every-other-day"
                                                )}
                                            </option>
                                            <option value="towel-change-every-day" className="towel-frequency-everyday">
                                                {T(
                                                    "checkin.take-care-environment.towell-replacement-frequency.everyday"
                                                )}
                                            </option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <hr />
                            </>}
                            {false && <fieldset className="mb-1 mt-4">
                                <legend>
                                    <Form.Check inline id="chkRestaurant">
                                        <Form.Check.Input
                                            className="ml-1 mr-2"
                                            checked={
                                                checkIn.extraData
                                                    ? checkIn.extraData["restaurantReservation"]
                                                    : false
                                            }
                                            onChange={(event) =>
                                                setExtraData(
                                                    "restaurantReservation",
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        <Form.Check.Label className="font-size-normal text-left">
                                            {T("checkin.restaurant-reservation")}
                                        </Form.Check.Label>
                                    </Form.Check>
                                </legend>
                                {/* <Objective className="d-flex flex-column" invalid={invalid1} /> */}
                            </fieldset>}

                            {false && <fieldset className="mb-1 mt-4">
                                <legend>
                                    <Form.Check inline id="chkParking">
                                        <Form.Check.Input
                                            className="ml-1 mr-2"
                                            checked={
                                                checkIn.extraData ? checkIn.extraData["parking"] : false
                                            }
                                            onChange={(event) =>
                                                setExtraData("parking", event.target.checked)
                                            }
                                        />
                                        <Form.Check.Label className="font-size-normal text-left">
                                            Check here if you want to reserve a <b>Garage</b>
                                        </Form.Check.Label>
                                    </Form.Check>
                                </legend>
                                {/* <Objective className="d-flex flex-column" invalid={invalid1} /> */}
                            </fieldset>}

                            {checkIn.status === "pending" && !isHostz(hotel.id) && (
                                <>
                                    <h5 className="text-subtitle mt-3 text-center">
                                        {T("checkin.comments")}
                                    </h5>
                                    {editMode && (
                                        <p className="general-text-sm text-center">
                                            {T("checkin.comments-text")}
                                        </p>
                                    )}
                                    {editMode && (
                                        <Form.Control
                                            className="mb-3"
                                            type={"textarea"}
                                            value={checkIn.comment}
                                            as="textarea"
                                            rows={5}
                                            onChange={(event) => {
                                                setComment(event.target.value);
                                            }}
                                            isInvalid={errors.comment}
                                        />
                                    )}
                                </>
                            )}

                            {(isRoyal(hotel.id) || isDemo(hotel.id)) && checkIn.travelType === "business" && (
                                <div className="p-4 border-top border-bottom border-left border-right mb-5">
                                    <h5 className="text-subtitle text-center">
                                        {T("checkin.company-information")}
                                    </h5>
                                    <p className="general-text-sm text-center">
                                        {T("checkin.company-information-text")}
                                    </p>
                                    <Form.Group>
                                        <Form.Control
                                            type="text"
                                            placeholder={T("checkin.company-name-placeholder")}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["company"]?.name || ""
                                                    : ""
                                            }
                                            onChange={(event) => {
                                                const company = checkIn.extraData?.company || {};
                                                setExtraData("company", {
                                                    ...company,
                                                    name: event.target.value
                                                });
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <InputGroup>
                                            <Form.Control
                                                as={'select'}
                                                placeholder={T('checkin.company-country-placeholder')}
                                                onChange={event => {
                                                    const company = checkIn.extraData?.company || {};
                                                    setExtraData("company", {
                                                        ...company,
                                                        country: event.target.value
                                                    });
                                                }}
                                            >
                                                <option value="" selected={checkIn.extraData?.company?.country === '' ? 'selected' : ''}>{T('checkin.company-country-placeholder')}</option>
                                                {Object.values(sortedCountries).map((val, idx) => (
                                                    <option value={val.code} selected={checkIn.extraData?.company?.country === val.code ? 'selected' : ''}>{val.name}</option>
                                                ))}
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Control
                                            type="text"
                                            placeholder={T("checkin.company-address-placeholder")}
                                            value={
                                                checkIn.extraData
                                                    ? checkIn.extraData["company"]?.address || ""
                                                    : ""
                                            }
                                            onChange={(event) => {
                                                const company = checkIn.extraData?.company || {};
                                                setExtraData("company", {
                                                    ...company,
                                                    address: event.target.value
                                                });
                                            }}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Row>
                                            <Col xs={8}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={T("checkin.company-city-placeholder")}
                                                    value={
                                                        checkIn.extraData
                                                            ? checkIn.extraData["company"]?.city || ""
                                                            : ""
                                                    }
                                                    onChange={(event) => {
                                                        const company = checkIn.extraData?.company || {};
                                                        setExtraData("company", {
                                                            ...company,
                                                            city: event.target.value
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <Col xs={4}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={T("checkin.company-zip-code-placeholder")}
                                                    value={
                                                        checkIn.extraData
                                                            ? checkIn.extraData["company"]?.zipCode || ""
                                                            : ""
                                                    }
                                                    onChange={(event) => {
                                                        const company = checkIn.extraData?.company || {};
                                                        setExtraData("company", {
                                                            ...company,
                                                            zipCode: event.target.value
                                                        });
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </div>
                            )}

                        </>
                    ) /* End step 3 */
                }

                {
                    editMode && !sending && currentStep === "cups" && (
                        <UpSellingListContainer
                            cupsList={filteredCupsList}
                            lang={language}
                            travelType={checkIn.travelType}
                            arrivalMode={checkIn.arrivalMode}
                            currency={paymentCurrency || checkIn.reservation?.balance?.currency}
                            checkInId={checkIn.id}
                        />
                    )
                }

                {
                    editMode && !sending && currentStep === "payment" && (
                        <>
                            {paymentError && (
                                <div className="text-danger font-size-sm d-block mt-1">
                                    {paymentError}
                                </div>
                            )}
                            <div>
                                {paymentComponentVersion === "v1" &&
                                    <PaymentCart
                                        checkIn={checkIn}
                                        language={language}
                                        currency={paymentCurrency}
                                        data={cartNew}
                                        onChangeState={handleChangePaymentState}
                                        onChangeOmmited={handleChangeOmmited}
                                        showTotalText={true}
                                        config={{
                                            optionPayLater: (optionPayLater && !showPaymentByUpselling),
                                        }}
                                    />}
                                {paymentComponentVersion === "v2" && <div style={{ minHeight: 400 }}>
                                    <div ref={paymentCheckoutRef} className="payment" />
                                    <PaymentControls />
                                    {/* <PaymentControls checkoutRef={paymentCheckoutRef} currentStep={currentStep} /> */}
                                </div>}
                            </div>
                        </>
                    )
                }

                {editMode && !sending && currentStep === "summary" && (
                    <>

                        <p className="font-size-sm mt-5 text-center d-block p-4">
                            {T("checkin.review-the-summary")}
                        </p>


                        <div className="mt-4 mb-4">
                            <Container
                                className={`card-generic mb-4 ${isKioskMode ? 'kiosk-card-generic' : 'shadow'}`}
                                style={{
                                    borderColor: "#f3f3f3",
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                }}
                            >
                                <h5 className="text-subtitle mt-2 mb-3">
                                    <FontAwesomeIcon icon={faUsers} className={`mr-1  ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`} />{" "}
                                    {T("general.guests")}{" "}
                                    {!checkIn.linked_checkins && <span className="font-italic text-muted font-size-sm">
                                        ({guestsText})
                                    </span>}
                                </h5>
                                {checkIn.passengers &&
                                    checkIn.passengers.map((p, idx) => <PassengerItemResume checkIn={checkIn} passenger={p} idx={idx} />)}

                                {checkIn.linked_checkins && checkIn.linked_checkins.map((linked_checkin, linked_checkin_idx) => (<>
                                    <h6 className="text-subtitle mt-4 mb-4">{T('checkin.room')} {linked_checkin_idx + 2}</h6>
                                    {linked_checkin.passengers && linked_checkin.passengers.map((p, idx) => <PassengerItemResume checkIn={linked_checkin} linked_checkin_idx={linked_checkin_idx} passenger={p} idx={idx} />)}
                                </>))}

                            </Container>
                        </div>

                        <div className="kiosk-separator"></div>
                        <div className={`${isKioskMode ? '' : 'mt-4 mb-4'}`}>


                            {/* <Row>
                  <Col xs={5}>
                    <p className="mb-2 font-size-sm">Entrada / Salida</p>
                    <p className="mb-2 font-size-sm">Tipo de Viaje</p>
                    <p className="mb-2 font-size-sm">Email</p>
                  </Col>
                  <Col xs={7}>
                    <p className="mb-2 font-size-sm font-weight-bold">{invertDate(formatDate(checkIn.reservation.arrival, false))} <FontAwesomeIcon icon={faLongArrowAltRight} className="mr-1 ml-1 text-muted" /> {invertDate(formatDate(checkIn.reservation.departure, false))}</p>
                    <p className="mb-2 font-size-sm font-weight-bold">{checkIn.travelType}</p>
                    <p className="mb-2 font-size-sm font-weight-bold">{checkIn.email}</p>
                  </Col>
                </Row> */}
                            {stayResume}
                        </div>
                        <div className="kiosk-separator"></div>
                        <div>

                            {checkIn.crossUpSelling && checkIn.crossUpSelling.length > 0 && (
                                <div className={`${isKioskMode ? '' : 'mt-4 mb-4'}`}>
                                    <Card className={isKioskMode ? 'kiosk-card-generic' : 'shadow'} border="default text-left">
                                        <h5 className="text-subtitle mt-3 ml-3">
                                            <FontAwesomeIcon icon={faPlusCircle} className={`mr-1 ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`} />{" "}
                                            {T("cups.title")}{" "}
                                            <span className="font-italic text-muted font-size-sm">
                                                {`(${checkIn.crossUpSelling.length} ${T("general.experiences")})`}
                                            </span>
                                        </h5>
                                        <Card.Body className="py-2 px-3">
                                            {checkIn.crossUpSelling.map((cup, idx) => {
                                                let _desc = htmlToText(i18nValue(cup, "description", language))
                                                if (_desc.length > 150) {
                                                    _desc = _desc.substring(0, 150) + "..."
                                                }
                                                const cupPrice = cup.optionSelected?.price ?? cup.price;
                                                const isPackage = cup.type === "items" || cup.optionSelected?.type === "items";
                                                const packageItems = cup.optionSelected?.items ?? (typeof cup.extra === "string" ? (() => { try { const e = JSON.parse(cup.extra); return e?.items; } catch { return null; } })() : null) ?? [];
                                                return (
                                                    <Row
                                                        className="mb-2"
                                                        style={{
                                                            ...(checkIn.crossUpSelling.length > 1 && { borderBottom: "1px solid #EEE" }),
                                                        }}
                                                        key={idx}
                                                    >
                                                        <Col xs={12}>
                                                            <div className="d-flex" style={{ gap: 15 }}>
                                                                <div
                                                                    style={{
                                                                        flex: "none",
                                                                        width: 75,
                                                                        height: 75,
                                                                        borderRadius: 5,
                                                                        borderColor: "#AAA",
                                                                        borderWidth: 1,
                                                                        borderStyle: "solid",
                                                                        textAlign: "center",
                                                                        background: "#EEE",
                                                                        verticalAlign: "middle",
                                                                        marginBottom: "5px"
                                                                    }}
                                                                >
                                                                    {cup?.photo && (
                                                                        <img
                                                                            style={{ width: 75, height: 75, borderRadius: 5, objectFit: "cover" }}
                                                                            src={getCDNImage(cup.photo)}
                                                                        />
                                                                    )}
                                                                    {!cup?.photo && (
                                                                        <div style={{ marginTop: 15 }}>
                                                                            <Building width={40} height={40} color="#666666" />
                                                                        </div>
                                                                    )}

                                                                </div>
                                                                <div className="flex-fill">
                                                                    <div className="d-flex justify-content-between">
                                                                        <p className="mb-0">
                                                                            {i18nValue(cup, "title", language)}
                                                                            {isPackage && (
                                                                                <span className="badge badge-secondary ml-1 font-size-xs" style={{ verticalAlign: 'middle' }}>{T('services.type.items_sales')}</span>
                                                                            )}
                                                                        </p>
                                                                        {!cup?.priceHidden && <>
                                                                            {cupPrice === 0 && <span className="general-text text-success font-size-sm">
                                                                                <b>{T("general.no-charge")}</b>
                                                                            </span>}
                                                                        </>}
                                                                        {cupPrice > 0 && <div className="text-center font-size-sm font-weight-bold">
                                                                            {paymentCurrency}{cupPrice}
                                                                        </div>}
                                                                    </div>
                                                                    <p className="general-text-sm mb-1">
                                                                        {_desc}
                                                                    </p>
                                                                    {isPackage && Array.isArray(packageItems) && packageItems.length > 0 && (
                                                                        <div className="font-size-sm text-muted mb-1" style={{ background: "#f8f9fa", padding: "6px 10px", borderRadius: 6 }}>
                                                                            {packageItems.map((item, i) => (
                                                                                <div key={item?.id || i} className="py-0">{i18nValue(item, "name", language)}</div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                    {cup?.bookData &&
                                                                        <>
                                                                            {cup.optionSelected && !isPackage && <div style={{ background: "#EEE", padding: "8px 12px", borderRadius: 8 }}>
                                                                                <p className="font-size-sm mb-0">{i18nValue(cup.optionSelected, "name", language)}</p>
                                                                            </div>}
                                                                            <div className="d-flex justify-content-between pt-2">
                                                                                <div className="font-size-sm d-inline d-flex justify-content-end text-success mt-0">{T('cups.booked')}</div>
                                                                                <div className="font-size-sm d-inline d-flex justify-content-end text-success"> {`${format(parseISO(cup.bookData.day), " dd MMM yyyy", { locale: getLocale(language) })} - ${cup.bookData.hour} -  ${cup.bookData.qty} ${T("cups.spots")}`}</div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    <div className="d-flex justify-content-end p-1">
                                                                        {cup?.availabilityStatus && <div className="text-danger text-center font-size-sm mr-2" >{T('cups.subject_to_availability')}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )
                                            })}
                                        </Card.Body>
                                    </Card>
                                </div>
                            )}

                            <div className="kiosk-separator"></div>
                            {guidelineContent && (
                                <div className={`${isKioskMode ? '' : 'mt-4 mb-4'}`}>
                                    <Card className={isKioskMode ? 'kiosk-card-generic' : 'shadow'} border="default text-left">
                                        <h5 className="text-subtitle mt-3 ml-3">
                                            <FontAwesomeIcon icon={faExclamationCircle} className={`mr-1 ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`} />{""}
                                            {T("general.guidelines")}{" "}
                                        </h5>
                                        <Card.Body className="py-2 px-3">
                                            <Row>
                                                <Col xs={12}>
                                                    <p className="guideline-content font-size-sm mt-3 mb-3 text-left d-block">
                                                        {guidelineContent}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </div>
                            )}

                            <div className="kiosk-separator"></div>
                            <div className={`${isKioskMode ? '' : 'mt-4 mb-4'}`}>
                                <Card className={isKioskMode ? 'kiosk-card-generic last' : 'shadow'}>
                                    <h5 className="text-subtitle mt-3 ml-3">
                                        <FontAwesomeIcon icon={faPen} className={`mr-1 ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`} />{" "}
                                        {T("checkin.signature")}   </h5>
                                    <Card.Body className="py-2 px-3">
                                        <TermsAndConditionsModal language={language} showIsForeignMsg={showIsForeignMsg} />
                                        <SignModal />
                                        <Row className="mb-3">
                                            <Col xs={12}>
                                                {!checkIn.sign &&
                                                    <div className="text-center p-2" style={{ background: '#EEE', borderRadius: 5, border: '1px solid #DDD' }}>
                                                        <Button
                                                            size={"sm"}
                                                            variant={"link"}
                                                            type={"button"}
                                                            className={"text-muted"}
                                                            style={{ height: '70px', width: '100%', textDecoration: 'none', border: 'none' }}
                                                            onClick={() => {
                                                                setShowSignModal(true)
                                                            }}
                                                        >

                                                            {T("checkin.please-sign-here")}

                                                        </Button>
                                                    </div>
                                                }
                                            </Col>
                                            <Col xs={12}>
                                                {checkIn.sign && <>
                                                    <div className="text-center p-2" style={{ background: '#EEE', borderRadius: 5, border: '1px solid #DDD' }}>

                                                        <div className="d-flex justify-content-center align-items-center" style={{ height: 70 }}>
                                                            <img style={{ maxHeight: 70, maxWidth: "90%" }} src={getCDNImage(checkIn.sign)} />
                                                        </div>
                                                        <div>
                                                            <Button
                                                                size={"sm"}
                                                                variant={"link"}
                                                                type={"button"}
                                                                className={"text-muted"}
                                                                onClick={() => {
                                                                    setSign(null);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faTimesCircle}
                                                                />{" "}
                                                                {T("general.clear")}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </>}
                                                {errors.sign && <span className="text-danger font-size-sm d-block mt-1">{T(errors.sign)}</span>}
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </div>

                            {isNewsletterHotel(hotel?.id) && (
                                <div className={`${isKioskMode ? '' : 'mt-4 mb-4'}`}>
                                    <Card className={isKioskMode ? 'kiosk-card-generic last' : 'shadow'}>
                                        <h5 className="text-subtitle mt-3 ml-3">
                                            <FontAwesomeIcon icon={faEnvelope} className={`mr-1 ${isKioskMode ? 'kiosk-icon' : 'text-danger'}`} />{" "}
                                            {T("checkin.newsletter")}
                                        </h5>
                                        <Card.Body className="py-2 px-3">
                                            <label
                                                htmlFor="newsletter-opt-in"
                                                className="d-flex align-items-center py-2"
                                                style={{ cursor: "pointer", gap: 14 }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id="newsletter-opt-in"
                                                    checked={!!checkIn?.newsletter}
                                                    onChange={e => setNewsletter(e.target.checked)}
                                                    style={{ cursor: "pointer", width: 22, height: 22, flexShrink: 0, accentColor: "#3699ff" }}
                                                />
                                                <span className="font-size-sm" style={{ lineHeight: 1.4 }}>
                                                    {T("checkin.newsletter-optin")}
                                                </span>
                                            </label>
                                        </Card.Body>
                                    </Card>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* {false && !editMode && !sending && lastMessages && lastMessages.count > 0 && <Row>
            <Col>
              <hr />
              <div className="general-text text-center mb-3 mt-2">Historial de mensajes</div>
              <Container className="card-generic shadow">
                {lastMessages.count > lastMessages.items.length && <p className="general-text-sm text-center text-muted">Hay {lastMessages.count - lastMessages.items.length} mensajes antiguos...</p>}
                {lastMessages.items.map(obs => {
                  return (<div className={`d-flex general-text-sm my-1`} key={obs.id}>
                    <span style={{ width: 65 }}>{new Date(obs.createdAt).toLocaleDateString('es-AR')}</span>
                    <p style={{ flex: 1 }} className="general-text-sm text-left mb-0">{obs.comment}</p>
                  </div>)
                })}
                <div className='text-right'>
                  <Button
                    size={'sm'}
                    variant={'link'}
                    className="text-decoration-none mt-1"
                    onClick={() => { navigate(`messages`) }}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} className="mr-1" /> Enviar Mensaje
                  </Button>
                </div>
              </Container>
            </Col>
          </Row>} */}

            </div>

            <div className="flex-container-with-scrolling">
                {/* <Comments 
              items={checkIn.evolutions} 
              addComment={addComment}
              showAddComment={checkIn.status !== 'accepted' && checkIn.status !== 'completed' && checkIn.status !== 'done' && checkIn.status !== 'canceled'} 
              loadingItems={loadingEvolutions} 
              sendingComment={sendingComment}
              guest={checkIn?.passengers && checkIn.passengers.length > 0 ? checkIn.passengers[0] : null}
              hotel={hotel}  /> */}
            </div>

            {(!sending && checkIn) && (
                <div className={`${isKioskMode ? 'kiosk-checkin-footer-container container pr-0 pl-0' : 'footer-container'}`}>
                    {stepError && Object.keys(errors).length > 0 && <ErrorMessages errors={stepError} width="100%" />}
                    <Row className={`${isKioskMode ? 'w-100' : ''}`}>
                        <Col xs={6} className={`${isKioskMode ? 'pl-0' : 'pr-1'}`}>
                            {editMode &&
                                stepCurrentPosition > 1 &&
                                stepCurrentPosition <= steps.length && (
                                    <Button
                                        size={"lg"}
                                        variant={isKioskMode ? `secondary` : `primary`}
                                        type={"button"}
                                        block={true}
                                        className={"px-1"}
                                        onClick={() => goPrev()}
                                    >
                                        <FontAwesomeIcon
                                            icon={faArrowCircleLeft}
                                            className="mr-2"
                                        />{" "}
                                        {T("general.back")}
                                    </Button>
                                )}
                                {isKioskMode && stepCurrentPosition === 1 && (
                                    <Button
                                        size={"lg"}
                                        variant={"primary"}
                                        type={"button"}
                                        block={true}
                                        onClick={() => {
                                            localStorage.clear();
                                            stayClear();
                                            navigate(`/${hotel?.code}/checkin/identify`);
                                        }}
                                    >
                                        {T('kiosk.back')}
                                    </Button>
                                )}
                        </Col>
                        <Col xs={6} className={`${isKioskMode ? 'pr-0' : 'pl-1'}`}>
                            {editMode && stepCurrentPosition < steps.length && (
                                <Button
                                    size={"lg"}
                                    variant={isKioskMode ? `secondary` : `primary`}
                                    type={"button"}
                                    block={true}
                                    className={`px-1 ${nextDisabled && ('disabled')}`}
                                    onClick={() => goNext()}
                                >
                                    {isOffgrid(hotel.id) ? T("general.next_offgrid") : T("general.next")}
                                    {" "}
                                    <FontAwesomeIcon icon={faArrowCircleRight} className="ml-2" />
                                </Button>
                            )}
                            {editMode && currentStep === "summary" && (
                                <Button
                                    size={"lg"}
                                    variant={isKioskMode ? `secondary` : `primary`}
                                    type={"button"}
                                    block={true}
                                    className={isKioskMode ? `summary-button` : `btn-accept`}
                                    onClick={() => _sendToValidate()}
                                >
                                    {T("checkin.confirm")}
                                </Button>
                            )}
                        </Col>
                    </Row>
                    {!editMode && !isKioskMode && (
                        <Row>
                            <Col xs={12}>
                                <Button
                                    size={"lg"}
                                    variant={"primary"}
                                    type={"button"}
                                    block={true}
                                    onClick={() => {
                                        // SET NO SALUDO??
                                        navigate(`/${hotel.code}/checkin/status`)
                                    }}
                                >
                                    {T("general.go-to-my-stay")}
                                </Button>
                                <small className="d-block text-center mt-1">
                                    {TF("checkin.redirecting", [redirectCount])}
                                </small>
                            </Col>
                        </Row>
                    )}
                    {false && !editMode && (
                        <Row>
                            <Col xs={6} className={"pr-1"}>
                                {!editMode &&
                                    (checkIn.status === "pending" ||
                                        checkIn.status === "to_validate" ||
                                        checkIn.status === "observed") && (
                                        <Button
                                            size={"lg"}
                                            variant={"primary"}
                                            type={"button"}
                                            block={true}
                                            onClick={() => {
                                                setStepCurrentPosition(1);
                                                setEditMode(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPen} className="mr-1" />{" "}
                                            {T(`checkin.edit-data`)}
                                        </Button>
                                    )}
                                {checkIn.status === "done" && (
                                    <Button
                                        size={"lg"}
                                        variant={isKioskMode ? `secondary` : `primary`}
                                        type={"button"}
                                        block={true}
                                        className={"px-1"}
                                        onClick={() => {
                                            navigate(`/${hotel.code}/stay`, {
                                                state: { from: pathname },
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />{" "}
                                        {T("general.detail")}
                                    </Button>
                                )}
                            </Col>
                            <Col xs={6} className={"pl-1"}>
                                <Button
                                    size={"lg"}
                                    variant={"primary"}
                                    type={"button"}
                                    block={true}
                                    onClick={() => {
                                        navigate(`messages`);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faComment} className="mr-1" /> {T("general.chat")}
                                </Button>
                            </Col>
                        </Row>
                    )}
                </div>
            )}
            {/* <CheckinCompleted checkIn={checkIn} hotel={hotel} show={showDoneModal} onClose={() => setShowDoneModal(false)} /> */}
        </Screen>
    );
    
    // Envolver en kiosk wrapper si está en modo kiosk
    if (isKioskMode) {
        return (<>
            <div className="kiosk-checkin-wrapper">
            {/* {isKioskMode && editMode && <ProgressSteps steps={steps} activeStep={stepCurrentPosition} />} */}
                <div className="kiosk-checkin-container container">
                    {screenContent}
                </div>
            </div>
        </>);
    }
    
    return screenContent;
};

export default CheckInDetailNew;
